// tslint:disable-next-line:max-line-length
import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy, ChangeDetectorRef, ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FormValidationsService, QuoteDataCaptureService, ProductCodeValidators, UtilService, SERVICE_END_POINT, GoogleRecaptchaV2Service, AnalyticsService, AuthService } from '../../../../shared';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AppState } from '../../../../store/state/app.state';
import * as ReqQuoteCalcActions from '../../../../store/actions/request-quote-calculation.actions';
import * as ResQuoteCalcActions from '../../../../store/actions/response-quote-calculation.actions';
import { RefNo } from '../../../../model/ngrx/reference-number.model';
import { YourPension } from '../../../../model/ngrx/your-pension.model';
import * as RefNoActions from '../../../../store/actions/reference-number.actions';
import * as UserDataConfig from '../../config/user-data.config';
import { LoaderService } from 'src/app/shared/services/api-services/page-loader.service';
import { ButtonService } from 'src/app/shared/services/api-services/button-loader.service';
import { CurrencyFunctionalityService, DealPartnerFunctionalityService } from 'src/app/shared';
import { DependantDetails } from '../../../../model/ngrx/dependant-details.model';
import { AlertModal } from 'src/app/model/alert';
import { RecaptchaComponent } from 'ng-recaptcha';
import * as Rx from 'rxjs';
import * as moment from 'moment';
import * as CardRefreshActions from '../../../../store/actions/card-refresh.actions';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { Attributes, DisplayRuleToBeApplied, ComponentTypes } from 'src/app/model/ui-rule-response-model';
import { UIRulesService } from 'src/app/shared/services/api-services/ui-rules.service';
import { ATTRIBUTE_NAME_ID } from 'src/app/pages/user-details/config/ceding-fund-attribute-id';
import { SliderUiRuleConfig } from 'src/app/model/slider-ui-rule-model';
import { RadioBtnConfig } from 'src/app/model/radio.button.model';
import { RangeValidationConfig } from 'src/app/model/rangeValidation.model';
import { ATTRIBUTE_NAMES_CONST } from 'src/app/shared/services/api-constants/attribute-names-constant';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { debounceTime } from 'rxjs/operators';
import { ConfigLoaderService } from 'src/app/shared/services/api-services/configLoader.service';

@Component({
  selector: 'app-your-options-calculation',
  templateUrl: './your-options-calculation.component.html',
  styleUrls: ['./your-options-calculation.component.scss']
})
export class YourOptionsCalculationComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @ViewChild('captchaRef', { static: true }) captchaRef: RecaptchaComponent;

  @Output() emittedPageMode = new EventEmitter();
  @Input() editFlag;
  @Input() cardNumber;
  @Input() productChoiceData;
  @Output() currencyTooltipHandler: EventEmitter<any> = new EventEmitter<any>();
  public contentData;
  protected productCms;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public quoteForm: UntypedFormGroup;
  showIncomeSlider: boolean;
  showTaxfreeSlider: boolean;
  showTaxfreeInput: boolean;
  showSecondTaxfreeSlider: boolean;
  showSecondTaxfreeInput: boolean;
  // showInvSlider: boolean;
  reqQuoteCalculationStore: Observable<any[]>;
  quoteCalculationStore: Observable<any[]>;
  quoteRefNoStore: Observable<string>;
  referenceNumberStore: Observable<RefNo[]>;
  yourPensionStore: Observable<YourPension[]>;
  dependantDetailsStore: Observable<DependantDetails[]>;
  public productsChoiceStore: Observable<any[]>;
  public productsChoice: {};
  protected selectedProductCode: string;
  public tooltipModalConfig: AlertModal;
  yourPensionData: YourPension;
  referenceNumber: RefNo;
  fundingSource: string;
  selectedQuoteType: any;
  quoteRefNo: any;
  yourOptions: any;
  quoteresstore: any;
  calculatedTaxFreeLumSum: any;
  mode: string;
  selectedCardNumber: number;
  globalIndex: number;
  subscription: any;
  errormessage: string;
  editMode: boolean;
  disableInvestmentSlider: boolean = false;
  disableIncomeSlider: boolean = false;
  disableDependantIncomeSlider: boolean = false;
  selectedProduct: any;
  loadingFlag: boolean = false;
  fundAmount: number;
  ACEErrorString: string = null;
  sliderErrorVisible: boolean = false;
  multipleTaxfree: boolean = false;
  pensionArray: any;
  taxfreePerc: number;
  taxfreePercSecondary: number;
  taxFreeFund: number;
  taxFreeFundSecondary: number;
  dependantDetailsData: DependantDetails;
  private subscripBeforeLogin: Subscription;
  private subscriptn: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  private subscripYourPension: Subscription;
  public frequencyConfig: any;
  public disableMonthSlider: boolean = false;
  public periodOfIncomeSliderVisibility: boolean = false;
  private subscripEmitEdit: Subscription;
  isLocked = false;
  public lockedAlertModalConfig: AlertModal;
  displayACEFlag = false;
  aceAlertModal: AlertModal;
  largeMaturityValueACEErrorModalConfig: AlertModal;
  largeMaturityValueACEErrorFlag = false;
  guaranteedPeriodErrorFlag: boolean = false;
  termPlanFTRPErrorflag: boolean = false;
  private grecaptchaResponseKey: string;
  private ACECalCounter: number;
  public currentDateConfig = UserDataConfig.ElementsConfig.radioButtonStartDateConfig;
  protected startDateErrorFlag = false;
  protected currentDateFlag = false;
  protected startDateAge55ErrorFlag = false;
  cmsACE;
  cmsGenaralConstants;
  yourPensionACE;
  source: string;
  public dontShowMsgAgain: boolean;
  public noWarningMSg: boolean;
  private humanFlag = false;
  private randomNumber: number;
  private grecaptchaResponseSubject = new Rx.ReplaySubject();
  isWholeTerm: string = 'F';
  startDateBeforeFormChanged: string;
  private quickQuoteObj;
  private quickQuoteObjRes;
  currentAndStartDateError: boolean;
  private CMSData;
  CMSDataQuoteUnavailable;
  private personalDetailStoreData: any;
  public maturityValErrorFlag: boolean = false;
  showWarningforGuaranteedIncome = false;
  showWarningforDependentIncome = false;
  screenName;
  showWarningValueProtection = false;
  loginDetails: any;
  vpWarningFlag = false;
  enableDependantTooltip = false;
  annuitantDOB;
  header;
  hideValueProtectionWarningMessage = false;
  reCaptchaSiteKey = '';
  sourceAttributeObj: Attributes;
  sourceDisplayRules: DisplayRuleToBeApplied;
  productOptionsCompRules: ComponentTypes;
  public configData: any;
  public paymentAdvanceConfig: RadioBtnConfig;
  public paymentFrequencyConfig;
  public nprBenefitConfig: RadioBtnConfig;
  public selectedNprBenefitDisplayRule: DisplayRuleToBeApplied;
  public selectedIncomeIncreaseDisplayRule: DisplayRuleToBeApplied;
  public selectedValueProtectionDisplayRule: DisplayRuleToBeApplied;
  public selectedPeriodOfIncomeDisplayRule: DisplayRuleToBeApplied;
  public termYearConfig: SliderUiRuleConfig;
  public termMonthConfig: SliderUiRuleConfig;
  public sliderPeriodOfIncomeConfig: SliderUiRuleConfig;
  public sliderGuaranteedTermConfig: SliderUiRuleConfig;
  public sliderIncPercentageConfig: SliderUiRuleConfig;
  public sliderIncomeIncreaseConfig: SliderUiRuleConfig;
  public sliderVpConfig: SliderUiRuleConfig;
  public incomeMaturityConfig: RadioBtnConfig;
  public periodOfIncomeConfig;
  public tfcConfig: RadioBtnConfig;
  public incomeIncreaseConfig: RadioBtnConfig;
  public valueProtectionConfig: RadioBtnConfig;
  public commencementDateConfig: RangeValidationConfig;
  public startDateAgeRangeConfig: RangeValidationConfig;
  tooltipModal;
  public increaseIncomeOptions= this.userInputDetail.radioButtonincraeseincomeConfig.questionOptions;
  displayTooltipAlert = false;
  isDateInputRequired: boolean;

  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private router: Router,
    private store: Store<AppState>, private quoteDataCaptureService: QuoteDataCaptureService,
    private utilService: UtilService, private loaderService: LoaderService, private ref: ChangeDetectorRef,
    private buttonService: ButtonService, public el: ElementRef, private googleRecaptchaV2Service: GoogleRecaptchaV2Service,
    private analyticsService: AnalyticsService, private uiRulesService: UIRulesService, private authService: AuthService,
   private configLoaderService: ConfigLoaderService) {
    /* this.activatedRoute.data
      .subscribe((data) => {
        this.productOptionsCompRules = data.uiCompJson;
        this.configData = data.configJson;
      }); */
    this.userInputDetail.startDate.value = '';
    this.userInputDetail.taxfreeValueConfig.titleValue = '';
    this.userInputDetail.taxfreeValueConfig.value = '';
    this.userInputDetail.secondaryTaxfreeValueConfig.titleValue = '';
    this.userInputDetail.secondaryTaxfreeValueConfig.value = '';
    this.userInputDetail.fundValueConfig.value = '';
    this.cmsGenaralConstants = this.activatedRoute.snapshot.data.contentData.generalConstants;
    this.contentData = this.activatedRoute.snapshot.data.contentData.youroptionscalculations;
    this.lockedAlertModalConfig = this.activatedRoute.snapshot.data.contentData['modalConfigLocked'];
    this.productCms = this.activatedRoute.snapshot.data.contentData.productChoice;
    this.cmsACE = this.activatedRoute.snapshot.data.contentData.aceModal;
    // this.largeMaturityValueACEErrorModalConfig = this.cmsACE.largelargeMaturityValueACEErrorModal;
    this.yourPensionACE = this.activatedRoute.snapshot.data.contentData.yourPension;
    this.reqQuoteCalculationStore = this.store.select(STORE_VAL.req_quote_calculation);
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.yourPensionStore = this.store.select(STORE_VAL.your_pension);
    this.dependantDetailsStore = this.store.select(STORE_VAL.dependant_details);
    this.quickQuoteObj = this.store.select(STORE_VAL.quote_calculation);
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    // this.quickQuoteObj.subscribe(res => {
    //   if (res.length > 0) {
    //     this.quickQuoteObjRes = res[0];
    //   }
    // });
    /** Recaptcha sitekey for Prod  */
    if (window.location.href.includes('retirements.landg.com')) {
      this.reCaptchaSiteKey = '6LfJ6-MUAAAAAELVOgZ__ZSZY7VLMMvl6bbWWEdq';
    } else {
      this.reCaptchaSiteKey = '6Le86-MUAAAAAKWuTp-gQXRsv09eU-kjK-rSPxEe';

    }

    this.reqQuoteCalculationStore.subscribe(res => {
      if (res.length > 0) {
        this.yourOptions = res[0];
      } else if (!this.quoteDataCaptureService.checkIfObjEmpty(res)) {
        this.yourOptions = null;
      }
    });

    this.productsChoiceStore = this.store.select(STORE_VAL.quote_capture);
    this.productsChoiceStore.subscribe(res => {
      if (res.length > 0) {
        this.productsChoice = res[0];
      }
    });

    this.subscripYourPension = this.yourPensionStore.subscribe(res => {
      if (res.length > 0) {
        this.yourPensionData = res[0];
      }
    });

    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        if (this.referenceNumber && this.referenceNumber.editMode) {
          this.editMode = true;
        } else {
          this.editMode = false;
        }
      }
    });

    this.dependantDetailsStore.subscribe(res => {
      if (res.length > 0) {
        this.dependantDetailsData = res[0];
      }
    });
    this.quickQuoteObj.subscribe(res => {
      if (res.length > 0) {
        this.quickQuoteObjRes = res[0];
      }
    });
  }

  ngOnInit() {
    /** Step 3 : add js random() here to trigger the below request randomly between the range >6 && <=15, per requirement  */
    this.isDateInputRequired = this.configLoaderService.configuration.isDateInputRequired;
   
    const max = 16; const min = 6;
    this.randomNumber = Math.floor(Math.random() * (max - min)) + min;
    //console.log('random = ', this.randomNumber);

    this.aceAlertModal = this.cmsACE.aceModalError;
    if (this.productsChoice) {
      this.selectedProduct = this.productCms.products.find(p => p.productCode === this.productsChoice['product']).productName;
      this.selectedProductCode = this.productCms.products.find(p => p.productCode === this.productsChoice['product']).productCode;
      this.fundingSource = this.productsChoice['source'];
    }
    if (this.yourPensionData) {
      this.processPensionData();
    }
    this.GetCMSDataServiceMapper();
    this.GetCMSDataQuoteUnavailableMapper();
    this.updateHeaderAndLoadData();
    //this.setConfigs();
    this.subscripEmitEdit = this.utilService.emitCard.subscribe(
      (values) => {
        this.doChanges(values);
      }
    );
    this.resetErrorMessages();
    this.subscripBeforeLogin = this.quoteDataCaptureService.subsVar = this.quoteDataCaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDataCaptureService.subsVar = this.quoteDataCaptureService.invokeSaveFunction.subscribe(res => {
      this.saveProgress(res);
    });
    this.subscripLogout = this.quoteDataCaptureService.subsVar = this.quoteDataCaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    this.largeMaturityValueACEErrorModalConfig = this.cmsACE.largeMaturityValueACEErrorModal;

    const obj = new ParentFormAndElmModel(this.quoteForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
  }
  doChanges = (values) => {
    this.resetErrorMessages();
    if (values && values.editFlag) {
      this.mode = 'edit';
    } else if (values && !values.editFlag) {
      this.mode = 'view';
    }
    if (values && values.cardNumber) {
      this.selectedCardNumber = values.cardNumber;
    } else {
      this.selectedCardNumber = null;
    }
    if (this.mode === 'view' && this.selectedCardNumber) {
      this.mode = 'edit';
      this.proceedAsNormal(); // this.gotoNextPage(); 
    } else if (this.mode === 'edit' && this.selectedCardNumber) {
      this.enableEditMode();
      // deletion
    } else if (this.mode === 'view' && !this.selectedCardNumber) {
      this.enableViewMode();
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    this.resetErrorMessages();
  }
  /** Recaptcha Block */

  /** This is a method hooked up in a control in the UI */
  recaptchaCheckCall() {
    this.captchaRef.reset();
    this.captchaRef.execute();
  }

  /** This method will only be called if the recaptcha invisible v2 API returns a response -
   *  A response will only be ever provided if you are a human
   */
  successResponseReceivedEvent(response: string) {
    //console.log(response);
    this.grecaptchaResponseKey = response;
    this.grecaptchaResponseSubject.next(response);
  }
  /** End of Recaptcha Block */

  setConfigs() {
    this.setCommencementDateConfigData();
    this.setStartDateAgeRangeConfigData();
    this.setNprBenefitConfigData();
    this.setPaymentAdvanceConfigData();
    this.setPaymentFrequencyConfigData();
    this.setTermYearConfigData();
    this.setTermMonthConfigData();
    this.setPeriodOfIncomeConfigData();
    this.setSliderPeriodOfIncomeConfigData();
    this.setIncomeIncreaseConfigData();
    this.setvalueProtectionConfigData();
    this.setSliderIncomePercentageConfigData();
    this.setSliderIncomeIncreaseConfig();
    this.setSliderVpConfig();
  }

  setCommencementDateConfigData() {
    let commencementDateConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.commencementDateConfig,
      this.productOptionsCompRules);
    let productToFetch: DisplayRuleToBeApplied = new DisplayRuleToBeApplied(ATTRIBUTE_NAME_ID.productOptionsSection.product, this.selectedProduct.productCode);
    this.commencementDateConfig = this.uiRulesService.createMapperForRangeValidation(commencementDateConfigData, productToFetch, null, null);
  }

  setStartDateAgeRangeConfigData() {
    let startDateAgeRangeConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.startDateAgeRangeConfig,
      this.productOptionsCompRules);
    this.startDateAgeRangeConfig = this.uiRulesService.createMapperForRangeValidation(startDateAgeRangeConfigData, null, null, null);
  }

  setNprBenefitConfigData() {
    let nprBenefitConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.nprBenefit,
      this.productOptionsCompRules);
    let productToFetch: DisplayRuleToBeApplied = new DisplayRuleToBeApplied(ATTRIBUTE_NAME_ID.productOptionsSection.product, this.selectedProduct.productCode);
    this.nprBenefitConfig = this.uiRulesService.createMapperForRadioButton(nprBenefitConfigData, productToFetch, null, null);
    this.selectedNprBenefitDisplayRule = new DisplayRuleToBeApplied(ATTRIBUTE_NAME_ID.productOptionsSection.nprBenefit, this.nprBenefitConfig.questionOptions[0].code)
  }

  setPaymentAdvanceConfigData() {
    let paymentAdvanceConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.paymentAdvance,
      this.productOptionsCompRules);
    this.paymentAdvanceConfig = this.uiRulesService.createMapperForRadioButton(paymentAdvanceConfigData, this.selectedNprBenefitDisplayRule, null, null);
    let configToModify = (this.selectedProduct.productCode === 'C') ? "radioButtonAdvanceConfig" : (this.selectedProduct.productCode === 'H' ? "radioButtonAdvanceFTRPConfig" : "radioButtonAdvanceFTRPConfig");
    this.userInputDetail[configToModify].questionOptions = this.paymentAdvanceConfig.questionOptions;
  }

  setPaymentFrequencyConfigData() {
    let paymentFrequencyConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.paymentFrequency,
      this.productOptionsCompRules);
    this.paymentFrequencyConfig = this.uiRulesService.createMapperForRadioButton(paymentFrequencyConfigData, this.selectedNprBenefitDisplayRule, null, null);
    let configToModify = (this.selectedProduct.productCode === 'C') ? "radioButtonFrequencyConfig" : (this.selectedProduct.productCode === 'H' ? "radioButtonFTRPFrequencyConfig" : "radioButtonCORPFrequencyConfig");
    this.userInputDetail[configToModify].questionOptions = this.paymentFrequencyConfig.questionOptions;
  }

  setTermYearConfigData() {
    let termYearConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.termYear,
      this.productOptionsCompRules);
    this.termYearConfig = this.uiRulesService.createMapperForSlider(termYearConfigData, this.selectedNprBenefitDisplayRule, null, null);
    this.userInputDetail.sliderTermConfig.minValue = this.termYearConfig.minValue;
    this.userInputDetail.sliderTermConfig.maxValue = this.termYearConfig.maxValue;
    this.userInputDetail.sliderTermConfig.currentValue = this.termYearConfig.minValue;
  }

  setTermMonthConfigData() {
    let termMonthConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.termMonth,
      this.productOptionsCompRules);
    this.termMonthConfig = this.uiRulesService.createMapperForSlider(termMonthConfigData, this.selectedNprBenefitDisplayRule, null, null);
    this.userInputDetail.sliderMonthlyTermConfig.minValue = this.termMonthConfig.minValue;
    this.userInputDetail.sliderMonthlyTermConfig.maxValue = this.termMonthConfig.maxValue;
    this.userInputDetail.sliderMonthlyTermConfig.currentValue = this.termMonthConfig.minValue;
  }

  setPeriodOfIncomeConfigData() {
    let periodOfIncomeConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.periodOfIncome,
      this.productOptionsCompRules);
    this.periodOfIncomeConfig = this.uiRulesService.createMapperForRadioButton(periodOfIncomeConfigData, this.selectedNprBenefitDisplayRule, null, null);
    this.userInputDetail.radioButtonPeriodOfIncomeConfig.questionOptions = this.periodOfIncomeConfig.questionOptions;
  }

  setSliderPeriodOfIncomeConfigData() {
    let sliderPeriodOfIncomeConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.sliderPeriodOfIncome,
      this.productOptionsCompRules);
    this.sliderPeriodOfIncomeConfig = this.uiRulesService.createMapperForSlider(sliderPeriodOfIncomeConfigData, this.selectedValueProtectionDisplayRule, null, null);
    this.userInputDetail.sliderperiodOfIncomeConfig.minValue = this.sliderPeriodOfIncomeConfig.minValue;
    this.userInputDetail.sliderperiodOfIncomeConfig.maxValue = this.sliderPeriodOfIncomeConfig.maxValue;
    this.userInputDetail.sliderperiodOfIncomeConfig.currentValue = this.sliderPeriodOfIncomeConfig.minValue;
    this.selectedPeriodOfIncomeDisplayRule = new DisplayRuleToBeApplied(ATTRIBUTE_NAME_ID.productOptionsSection.sliderPeriodOfIncome, this.quoteForm.value.periodofincomequestion);
  }

  setSliderGuaranteedTermConfigData() {
    let sliderPeriodOfIncomeConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.sliderGuarateedTerm,
      this.productOptionsCompRules);
    this.sliderGuaranteedTermConfig = this.uiRulesService.createMapperForSlider(sliderPeriodOfIncomeConfigData, this.selectedPeriodOfIncomeDisplayRule, null, null);
    this.userInputDetail.sliderperiodOfIncomeConfig.minValue = this.sliderPeriodOfIncomeConfig.minValue;
    this.userInputDetail.sliderperiodOfIncomeConfig.maxValue = this.sliderPeriodOfIncomeConfig.maxValue;
    this.userInputDetail.sliderperiodOfIncomeConfig.currentValue = this.sliderPeriodOfIncomeConfig.minValue;
  }

  setIncomeIncreaseConfigData() {
    let incomeIncreaseConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.incomeIncrease,
      this.productOptionsCompRules);
    this.incomeIncreaseConfig = this.uiRulesService.createMapperForRadioButton(incomeIncreaseConfigData, this.selectedNprBenefitDisplayRule, null, null);
    this.userInputDetail.radioButtonincraeseincomeConfig.questionOptions = this.incomeIncreaseConfig.questionOptions;
    this.selectedIncomeIncreaseDisplayRule = new DisplayRuleToBeApplied(ATTRIBUTE_NAME_ID.productOptionsSection.incomeIncrease,
      this.quoteForm.value.increaseincome);
  }

  setSliderIncomeIncreaseConfig() {
    let sliderIncomeIncreaseConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.sliderIncomeIncrease,
      this.productOptionsCompRules);
    this.sliderIncomeIncreaseConfig = this.uiRulesService.createMapperForSlider(sliderIncomeIncreaseConfigData, this.selectedIncomeIncreaseDisplayRule, null, null);
    this.userInputDetail.sliderincreaseIncomeConfig.minValue = this.sliderIncomeIncreaseConfig.minValue;
    this.userInputDetail.sliderincreaseIncomeConfig.maxValue = this.sliderIncomeIncreaseConfig.maxValue;
    this.userInputDetail.sliderincreaseIncomeConfig.currentValue = this.sliderIncomeIncreaseConfig.minValue;
  }

  setvalueProtectionConfigData() {
    let valueProtectionConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.valueProtection,
      this.productOptionsCompRules);
    this.valueProtectionConfig = this.uiRulesService.createMapperForRadioButton(valueProtectionConfigData, this.selectedNprBenefitDisplayRule, null, null);
    this.userInputDetail.radioButtonvalueProtectionConfig.questionOptions = this.valueProtectionConfig.questionOptions;
    this.selectedValueProtectionDisplayRule = new DisplayRuleToBeApplied(ATTRIBUTE_NAME_ID.productOptionsSection.valueProtection,
      this.quoteForm.value.valueprotection);
  }

  setSliderVpConfig() {
    let sliderVpConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.sliderVpConfig,
      this.productOptionsCompRules);
    this.sliderVpConfig = this.uiRulesService.createMapperForSlider(sliderVpConfigData, this.selectedValueProtectionDisplayRule, null, null);
    this.userInputDetail.slidervpConfig.minValue = this.sliderVpConfig.minValue;
    this.userInputDetail.slidervpConfig.maxValue = this.sliderVpConfig.maxValue;
    this.userInputDetail.slidervpConfig.currentValue = this.sliderVpConfig.minValue;
    this.userInputDetail.slidervpConfig.stepsArray = this.sliderVpConfig.stepsArray;
  }

  setSliderIncomePercentageConfigData() {
    let sliderIncomePercentageConfigData = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.productOptionsSection.sliderIncomePercentageConfig,
      this.productOptionsCompRules);
    this.sliderIncPercentageConfig = this.uiRulesService.createMapperForSlider(sliderIncomePercentageConfigData, this.selectedNprBenefitDisplayRule, null, null);
    this.userInputDetail.sliderIncomePercentageConfig.minValue = this.sliderIncPercentageConfig.minValue;
    this.userInputDetail.sliderIncomePercentageConfig.maxValue = this.sliderIncPercentageConfig.maxValue;
    this.userInputDetail.sliderIncomePercentageConfig.currentValue = this.sliderIncPercentageConfig.minValue;
  }

  userFormDataPensionAnnuity = () => {
    this.userInputDetail.sliderperiodOfIncomeConfig.minValue = 0;
    this.userInputDetail.sliderperiodOfIncomeConfig.maxValue = 30;
    this.userInputDetail.sliderperiodOfIncomeConfig.infoIconFlag = true;
    this.userInputDetail.sliderperiodOfIncomeConfig.sliderTitleVisible = true;
    this.frequencyConfig = this.userInputDetail.radioButtonFrequencyConfig;
    this.userInputDetail.buttonAddCalculationConfig.label = this.contentData.calculateButton;
    this.userInputDetail.radioButtonincraeseincomeConfig.questionOptions = this.increaseIncomeValues()
    this.userInputDetail.sliderincreaseIncomeConfig.maxValue = 5;
    // this.userInputDetail.buttonConfig.showIcon = true;
    this.mode = 'view';
    if (this.yourOptions) {
      this.quoteForm = this.fb.group({
        currentDate: [this.yourOptions.currentDate],
        startDate: [this.yourOptions.startDate],
        increasedincome: [(this.yourOptions.increasedincome === 'R' || this.yourOptions.increasedincome === 'N')
          ? this.yourOptions.increasedincome :
          (this.yourOptions.increasedincome ? 'F' : ''), Validators.required],
        increasedincomeslider: [this.yourOptions.increasedincomeslider, null],
        vpslider: [this.yourOptions.vpslider, null],
        advance: [this.yourOptions.advance, Validators.required],
        frequency: [this.yourOptions.frequency, Validators.required],
        valueprotection: [this.yourOptions.valueprotection, Validators.required],
        periodofincome: [this.yourOptions.periodofincome, Validators.required],
        incomepercentage:
          [this.yourOptions.incomepercentage === 'N' ?
            0 : parseInt(this.yourOptions.incomepercentage), Validators.required],
        taxfreelumpsum: [this.yourOptions.taxfreelumpsum ?
          parseInt(this.yourOptions.taxfreelumpsum) : 0,
        [Validators.required, this.customValidator]],
        taxfreelumpsumSecondary: [this.yourOptions.taxfreelumpsumSecondary ?
          parseInt(this.yourOptions.taxfreelumpsumSecondary) : 0,
        [Validators.required, this.customValidator]],
        taxfreeRadioButton: [(this.yourOptions.taxfreeRadioButton ? this.yourOptions.taxfreeRadioButton : null), Validators.required],
        taxfreeRadioButtonSecondary: [(this.yourOptions.taxfreeRadioButtonSecondary ? this.yourOptions.taxfreeRadioButtonSecondary : null),
        Validators.required],
        fundValueTaxfree: [(this.yourOptions.fundValueTaxfree ? this.yourOptions.fundValueTaxfree : null),
        [Validators.required, this.customValidator]],
        fundValueTaxfreeSecondary: [(this.yourOptions.fundValueTaxfreeSecondary ? this.yourOptions.fundValueTaxfreeSecondary : null),
        [Validators.required, this.customValidator]],
        productType: 'C'
      });
      if (this.yourOptions.startDate) {
        this.userInputDetail.startDate.value = this.yourOptions.startDate;

      }
      if (this.yourOptions.increasedincome && this.yourOptions.increasedincome !== 'R'
        && this.yourOptions.increasedincome !== 'N' && this.yourOptions.increasedincome !== '') {
        this.showIncomeSlider = true;
      } else {
        this.showIncomeSlider = false;
      }
      if (this.yourOptions.taxfreeRadioButton) {
        this.showTaxfreeSlider = (this.yourOptions.taxfreeRadioButton === 'P') ? true : false;
        this.showTaxfreeInput = (this.yourOptions.taxfreeRadioButton === 'A') ? true : false;
      }
      if (this.yourOptions.taxfreeRadioButtonSecondary) {
        this.showSecondTaxfreeSlider = (this.yourOptions.taxfreeRadioButtonSecondary === 'P') ? true : false;
        this.showSecondTaxfreeInput = (this.yourOptions.taxfreeRadioButtonSecondary === 'A') ? true : false;
      }
      this.setTaxfreeLabel();
    } else {
      this.quoteForm = this.fb.group({
        currentDate: [null],
        startDate: [''],
        termplan: [null],
        fundValue: [null],
        incomematurity: [null],
        increasedincome: [null, Validators.required],
        increasedincomeslider: [null],
        vpslider: [25, Validators.required],
        advance: [null, Validators.required],
        frequency: [null, Validators.required],
        // tslint:disable-next-line:max-line-length
        valueprotection: [null, Validators.required],
        // (this.dependantDetailsData && (this.dependantDetailsData.dependantQuestion === 'Y')) ? !Validators.required :
        periodofincome: [0, Validators.required],
        incomepercentage: [0, Validators.required],
        taxfreelumpsum: [0, [Validators.required, this.customValidator]],
        taxfreeRadioButton: [null, Validators.required],
        productType: 'C',
        fundValueTaxfree: [null, [Validators.required, this.customValidator]],
        taxfreeRadioButtonSecondary: [null, Validators.required],
        taxfreelumpsumSecondary: [0, [Validators.required, this.customValidator]],
        fundValueTaxfreeSecondary: [null, [Validators.required, this.customValidator]]
      });
    }
    this.userInputDetail.sliderIncomePercentageConfig.unselectedByDefault = true;
    this.userInputDetail.slidervpConfig.unselectedByDefault = true;
    if (this.yourOptions && (this.yourOptions.taxfreelumpsum || this.yourOptions.taxfreelumpsum !== null)) {
      this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault = false;
    } else {
      this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault = true;
    }
    if (this.yourOptions && (this.yourOptions.taxfreelumpsumSecondary || this.yourOptions.taxfreelumpsumSecondary !== null)) {
      this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault = false;
    } else {
      this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault = true;
    }
    if (this.dependantDetailsData && (this.dependantDetailsData.dependantQuestion === 'N')) {
      // this.userInputDetail.radioButtonvalueProtectionConfig.disabled = false;
      if (this.yourOptions && this.yourOptions.valueprotection) {
        this.quoteForm.controls['valueprotection'].setValue(this.yourOptions.valueprotection);
        this.enableDependantTooltip = this.yourOptions.valueprotection === 'Inc' ? true : false;
        this.vpWarningFlag = this.yourOptions.valueprotection === 'Ann' ? true : false;
        if (this.yourOptions.valueprotection === 'Ann') {
          this.resetSliderStatusValues(false, true, true, this.yourOptions.vpslider, 0, 0, false, { Ques: 'N', Selection: 'Ann' });
        } else if (this.yourOptions.valueprotection === 'Inc') {
          this.resetSliderStatusValues(true, false, true, 0, this.yourOptions.periodofincome, 0, false, { Ques: 'N', Selection: 'Inc' });
        } else if (this.yourOptions.valueprotection === 'Ne') {
          this.resetSliderStatusValues(true, true, true, 25, 0, 0, false, { Ques: 'N', Selection: 'Ne' });
        }
      } else {
        // NO
        // this.quoteForm.controls['valueprotection'].setValidators([Validators.required]);
        // this.quoteForm.controls['valueprotection'].updateValueAndValidity();
        this.quoteForm.controls['valueprotection'].setValue(null);
        this.resetSliderStatusValues(true, true, true, 25, 0, 0, true, { Ques: 'N', Selection: 'De' });

      }
      // this.disableInvestmentSlider = true;
      // this.quoteForm.controls['periodofincome'].setValue(0);
      // this.quoteForm.controls['incomepercentage'].setValue(0);
      // this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = false;
      // this.userInputDetail.sliderIncomePercentageConfig.unselectedByDefault = false;
    } else if (this.dependantDetailsData && (this.dependantDetailsData.dependantQuestion === 'Y')) {
      // Yes
      if (this.yourOptions && this.yourOptions.valueprotection) {
        this.enableDependantTooltip = this.yourOptions.valueprotection === 'Inc' ? true : false;
        this.vpWarningFlag = this.yourOptions.valueprotection === 'Ann' ? true : false;
        if (this.yourOptions.valueprotection === 'Ann') {
          this.resetSliderStatusValues(false, true, true, this.yourOptions.vpslider, 0, 0, false, { Ques: 'Y', Selection: 'Ann' });
        } else if (this.yourOptions.valueprotection === 'Inc') {
          // tslint:disable-next-line:max-line-length
          this.resetSliderStatusValues(true, false, false, 25, this.yourOptions.periodofincome, this.yourOptions.incomepercentage, false, { Ques: 'Y', Selection: 'Inc' });
        } else if (this.yourOptions.valueprotection === 'Ne') {
          this.resetSliderStatusValues(true, true, true, 25, 0, this.yourOptions.incomepercentage, false, { Ques: 'Y', Selection: 'Ne' });
        }


      } else {
        this.quoteForm.controls['valueprotection'].setValue(null);
        // this.quoteForm.controls['valueprotection'].clearValidators();
        // this.quoteForm.controls['valueprotection'].updateValueAndValidity();
        this.resetSliderStatusValues(true, true, true, 25, 0, 0, true, { Ques: 'Y', Selection: 'De' });
        // this.userInputDetail.radioButtonvalueProtectionConfig.disabled = true;
      }
    }
    this.quoteForm.setValidators(this.customValidator());
  }

  userFormDataFTRP = () => {
    // this.userInputDetail.sliderperiodOfIncomeConfig.validationMsg = '';
    this.userInputDetail.sliderperiodOfIncomeConfig.infoIconFlag = false;
    this.userInputDetail.sliderperiodOfIncomeConfig.minValue = 1;
    this.userInputDetail.sliderperiodOfIncomeConfig.sliderTitleVisible = false;
    this.frequencyConfig = this.userInputDetail.radioButtonFTRPFrequencyConfig;
    this.userInputDetail.buttonAddCalculationConfig.label = this.contentData.calculateButton;
    this.userInputDetail.radioButtonincraeseincomeConfig.questionOptions = this.increaseIncomeOptions.slice(0,2)
    this.userInputDetail.sliderincreaseIncomeConfig.maxValue = 10;
    // this.userInputDetail.buttonConfig.showIcon = true;
    this.mode = 'view';
    if (this.yourOptions) {
      const taxfreeamount = parseInt(this.yourOptions.taxfreelumpsum) || 0;
      this.quoteForm = this.fb.group({
        currentDate: [this.yourOptions.currentDate],
        startDate: [this.yourOptions.startDate],
        termplan: [this.yourOptions.termplan, this.customValidator],
        termmonth: [this.yourOptions.termmonth, this.customValidator],
        increasedincome: [(this.yourOptions.increasedincome === 'R' || this.yourOptions.increasedincome === 'N')
        ? this.yourOptions.increasedincome :
        (this.yourOptions.increasedincome ? 'F' : ''), Validators.required],
        increasedincomeslider: [this.yourOptions.increasedincomeslider, null],
        advance: [this.yourOptions.advance, Validators.required],
        frequency: [this.yourOptions.frequency, Validators.required],
        periodofincome: [this.yourOptions.periodofincome, Validators.required],
        periodofincomequestion: [this.yourOptions.periodofincomequestion, Validators.required],
        fundValue: [this.yourOptions.fundValue, Validators.required],
        incomematurity: [this.yourOptions.incomematurity, Validators.required],
        taxfreelumpsum: [this.yourOptions.taxfreelumpsum ?
          parseInt(this.yourOptions.taxfreelumpsum) : 0,
        [Validators.required, this.customValidator]],
        taxfreelumpsumSecondary: [this.yourOptions.taxfreelumpsumSecondary ?
          parseInt(this.yourOptions.taxfreelumpsumSecondary) : 0,
        [Validators.required, this.customValidator]],
        taxfreeRadioButton: [(this.yourOptions.taxfreeRadioButton ? this.yourOptions.taxfreeRadioButton : null), Validators.required],
        taxfreeRadioButtonSecondary: [(this.yourOptions.taxfreeRadioButtonSecondary ? this.yourOptions.taxfreeRadioButtonSecondary : null),
        Validators.required],
        fundValueTaxfree: [(this.yourOptions.fundValueTaxfree ? this.yourOptions.fundValueTaxfree : null),
        [Validators.required, this.customValidator]],
        fundValueTaxfreeSecondary: [(this.yourOptions.fundValueTaxfreeSecondary ? this.yourOptions.fundValueTaxfreeSecondary : null),
        [Validators.required, this.customValidator]],
        productType: 'H'
      });

      if (this.yourOptions.increasedincome && this.yourOptions.increasedincome !== 'R'
               && this.yourOptions.increasedincome !== 'N' && this.yourOptions.increasedincome !== '') {
            this.showIncomeSlider = true;
      } else {
            this.showIncomeSlider = false;
      }
      if (this.yourOptions.startDate) {
        this.userInputDetail.startDate.value = this.yourOptions.startDate;

      }
      if (this.quoteForm && this.yourOptions && this.yourOptions.periodofincomequestion) {
        this.periodOfIncomeSliderVisibility = this.yourOptions.periodofincomequestion && this.yourOptions.periodofincomequestion === 'O' ? true : false;
      }
      if (this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'Y') &&
        this.quoteForm.controls['fundValue'].value.toString() === '0') {
        this.userInputDetail.radioButtonAdvanceFTRPConfig.disabled = true;
        this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = true;
      } else if (this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'M') &&
        this.quoteForm.controls['fundValue'].value.toString() === '0') {
        this.userInputDetail.radioButtonAdvanceFTRPConfig.disabled = false;
        this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
      }
      if (this.yourOptions.fundValue && !this.yourOptions.fundValue.toString().includes(',') && !this.editMode) {
        // tslint:disable-next-line:max-line-length
        this.userInputDetail.fundValueConfig.value = CurrencyFunctionalityService.convertNumberToCurrency(parseFloat(this.yourOptions.fundValue));
      } else if (this.yourOptions.fundValue && !this.editMode) {
        // tslint:disable-next-line:max-line-length
        this.userInputDetail.fundValueConfig.value = this.yourOptions.fundValue;
      }
      if (this.yourOptions && this.yourOptions.termplan) {
        this.userInputDetail.sliderTermConfig.unselectedByDefault = false;
        // this.userInputDetail.sliderTermConfig.currentValue = this.yourOptions.termplan;
        // this.userInputDetail.sliderMonthlyTermConfig.currentValue = this.yourOptions.termmonth;
        this.userInputDetail.sliderperiodOfIncomeConfig.maxValue = this.yourOptions.termplan;
      }
      if (this.yourOptions && (this.yourOptions.termmonth || this.yourOptions.termmonth != null)) {
        this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault = false;
      }
      if (this.yourOptions && (this.yourOptions.periodofincome || this.yourOptions.periodofincome !== null || this.yourOptions.periodofincome !== 0)) {
        this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = false;
      }
      if (this.yourOptions.taxfreeRadioButton) {
        this.showTaxfreeSlider = (this.yourOptions.taxfreeRadioButton === 'P') ? true : false;
        this.showTaxfreeInput = (this.yourOptions.taxfreeRadioButton === 'A') ? true : false;
      }
      if (this.yourOptions.taxfreeRadioButtonSecondary) {
        this.showSecondTaxfreeSlider = (this.yourOptions.taxfreeRadioButtonSecondary === 'P') ? true : false;
        this.showSecondTaxfreeInput = (this.yourOptions.taxfreeRadioButtonSecondary === 'A') ? true : false;
      }
      if (this.yourOptions && (this.yourOptions.taxfreelumpsum || this.yourOptions.taxfreelumpsum != null)) {
        this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault = false;
      } else {
        this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault = true;
      }
      if (this.yourOptions && (this.yourOptions.taxfreelumpsumSecondary || this.yourOptions.taxfreelumpsumSecondary != null)) {
        this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault = false;
      } else {
        this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault = true;
      }
      let questionOptions = this.userInputDetail.radioButtonFTRPFrequencyConfig.questionOptions;
      if (this.yourOptions.termplan === 25) {
        this.resetFrequency(questionOptions, true);
        this.setFrequency({ currentValue: 0 }, questionOptions);
      } else {
        this.resetFrequency(questionOptions, false);
        this.setFrequency({ currentValue: this.yourOptions.termmonth }, questionOptions);
      }
      this.quoteForm.controls['frequency'].setValue(this.yourOptions.frequency);
      this.setTaxfreeLabel();
      this.utilService.refreshToggleButton();
    } else {
      this.quoteForm = this.fb.group({
        currentDate: [null],
        startDate: [''],
        termplan: [3, this.customValidator],
        termmonth: [null, this.customValidator],
        fundValue: [null, [Validators.required, this.customValidator]],
        incomematurity: [null, [Validators.required, this.customValidator]],
        increasedincome: [null, Validators.required],
        increasedincomeslider: [ null],
        vpslider: [25],
        advance: [null, Validators.required],
        frequency: [null, Validators.required],
        valueprotection: [null],
        periodofincome: [0, [Validators.required, this.customValidator]],
        periodofincomequestion: [this.isWholeTerm, Validators.required],
        incomepercentage: [null],
        taxfreelumpsum: [0, [Validators.required, this.customValidator]],
        taxfreeRadioButton: [null, Validators.required],
        productType: 'H',
        fundValueTaxfree: [null, [Validators.required, this.customValidator]],
        taxfreeRadioButtonSecondary: [null, Validators.required],
        taxfreelumpsumSecondary: [0, [Validators.required, this.customValidator]],
        fundValueTaxfreeSecondary: [null, [Validators.required, this.customValidator]]
      });
      this.userInputDetail.sliderperiodOfIncomeConfig.maxValue = this.userInputDetail.sliderTermConfig.minValue;
      this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = true;
      if (this.yourOptions && this.yourOptions.taxfreelumpsum) {
        this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault = false;
      } else {
        this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault = true;
      }
      if (this.yourOptions && this.yourOptions.taxfreelumpsumSecondary) {
        this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault = false;
      } else {
        this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault = true;
      }
      this.userInputDetail.sliderTermConfig.unselectedByDefault = true;
      this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault = true;
      this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = true;
      this.quoteForm.controls['termplan'].markAsUntouched();
      this.quoteForm.controls['termmonth'].markAsUntouched();
      // this.quoteForm.controls.periodofincomequestion.setValue('F');
    }
    this.quoteForm.controls.periodofincomequestion.setValue('F');
    this.quoteForm.setValidators(this.customValidator());
  }

  userFormDataCORP = () => {
    // this.userInputDetail.sliderperiodOfIncomeConfig.validationMsg = 'Please make a selection';
    this.userInputDetail.buttonAddCalculationConfig.label = this.contentData.calculateButton;
    this.userInputDetail.sliderTermConfig.infoIconFlag = false;
    this.userInputDetail.radioButtonincraeseincomeConfig.questionOptions = this.increaseIncomeOptions.slice(0,2)
    this.userInputDetail.sliderincreaseIncomeConfig.maxValue = 10;
    this.mode = 'view';
    if (this.yourOptions) {
      const taxfreeamount = parseInt(this.yourOptions.taxfreelumpsum) || 0;
      this.quoteForm = this.fb.group({
        currentDate: [this.yourOptions.currentDate],
        startDate: [this.yourOptions.startDate],
        increasedincome: [(this.yourOptions.increasedincome === 'R' || this.yourOptions.increasedincome === 'N')
        ? this.yourOptions.increasedincome :
        (this.yourOptions.increasedincome ? 'F' : ''), Validators.required],
        increasedincomeslider: [this.yourOptions.increasedincomeslider, null],
        termyear: [this.yourOptions.termyear, [Validators.required, this.customValidator]],
        termmonth: [this.yourOptions.termmonth, [Validators.required, this.customValidator]],
        advance: [this.yourOptions.advance, Validators.required],
        frequency: [this.yourOptions.frequency, Validators.required],
        taxfreelumpsum: [this.yourOptions.taxfreelumpsum ?
          parseInt(this.yourOptions.taxfreelumpsum) : 0,
        [Validators.required, this.customValidator]],
        taxfreelumpsumSecondary: [this.yourOptions.taxfreelumpsumSecondary ?
          parseInt(this.yourOptions.taxfreelumpsumSecondary) : 0,
        [Validators.required, this.customValidator]],
        taxfreeRadioButton: [(this.yourOptions.taxfreeRadioButton ? this.yourOptions.taxfreeRadioButton : null), Validators.required],
        taxfreeRadioButtonSecondary: [(this.yourOptions.taxfreeRadioButtonSecondary ? this.yourOptions.taxfreeRadioButtonSecondary : null),
        Validators.required],
        fundValueTaxfree: [(this.yourOptions.fundValueTaxfree ? this.yourOptions.fundValueTaxfree : null),
        [Validators.required, this.customValidator]],
        fundValueTaxfreeSecondary: [(this.yourOptions.fundValueTaxfreeSecondary ? this.yourOptions.fundValueTaxfreeSecondary : null),
        [Validators.required, this.customValidator]],
        productType: 'G'
      });
      
      if (this.yourOptions.increasedincome && this.yourOptions.increasedincome !== 'R'
               && this.yourOptions.increasedincome !== 'N' && this.yourOptions.increasedincome !== '') {
            this.showIncomeSlider = true;
      } else {
            this.showIncomeSlider = false;
      }
      if (this.yourOptions.startDate) {
        this.userInputDetail.startDate.value = this.yourOptions.startDate;

      }
      if (this.yourOptions && this.yourOptions.termyear) {
        this.userInputDetail.sliderTermConfig.unselectedByDefault = false;
      }
      if (this.yourOptions && (this.yourOptions.termmonth || this.yourOptions.termmonth != null)) {
        this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault = false;
      }
      if (this.yourOptions && (this.yourOptions.taxfreelumpsum || this.yourOptions.taxfreelumpsum != null)) {
        this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault = false;
      } else {
        this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault = true;
      }
      if (this.yourOptions && (this.yourOptions.taxfreelumpsumSecondary || this.yourOptions.taxfreelumpsumSecondary != null)) {
        this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault = false;
      } else {
        this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault = true;
      }
      if (this.yourOptions && this.yourOptions.frequency) {
        this.userInputDetail.radioButtonCORPFrequencyConfig.disabled = false;
      }
      if (this.yourOptions.taxfreeRadioButton) {
        this.showTaxfreeSlider = (this.yourOptions.taxfreeRadioButton === 'P') ? true : false;
        this.showTaxfreeInput = (this.yourOptions.taxfreeRadioButton === 'A') ? true : false;
      }
      if (this.yourOptions.taxfreeRadioButtonSecondary) {
        this.showSecondTaxfreeSlider = (this.yourOptions.taxfreeRadioButtonSecondary === 'P') ? true : false;
        this.showSecondTaxfreeInput = (this.yourOptions.taxfreeRadioButtonSecondary === 'A') ? true : false;
      }
      this.setTaxfreeLabel();
    } else {
      this.quoteForm = this.fb.group({
        currentDate: [null],
        startDate: [''],
        increasedincome: [null, Validators.required],
        increasedincomeslider: [ null],
        termyear: [3, [Validators.required, this.customValidator]],
        termmonth: [0, [Validators.required, this.customValidator]],
        frequency: [null, Validators.required],
        advance: [null, [Validators.required, this.customValidator]],
        taxfreelumpsum: [0, [Validators.required, this.customValidator]],
        taxfreeRadioButton: [null, Validators.required],
        productType: 'G',
        fundValueTaxfree: [null, [Validators.required, this.customValidator]],
        taxfreeRadioButtonSecondary: [null, Validators.required],
        taxfreelumpsumSecondary: [0, [Validators.required, this.customValidator]],
        fundValueTaxfreeSecondary: [null, [Validators.required, this.customValidator]]
      });
      this.userInputDetail.sliderTermConfig.unselectedByDefault = true;
      this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault = true;
      this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault = true;
    }
  }
  public customValidator(): ValidatorFn {
    return (group: UntypedFormGroup): ValidationErrors => {
      // const periodofincome = group.controls['periodofincome'];
      const taxfreelumpsum = group.controls['taxfreelumpsum'];
      // tslint:disable-next-line: max-line-length
      // if ((!periodofincome.value && !periodofincome.touched) || (periodofincome.touched && this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault)) {
      //   periodofincome.setErrors({ notValid: true });
      // } else {
      //   periodofincome.setErrors(null);
      // }
      if (this.selectedProduct.productCode === 'C') {
        // const incomepercentage = group.controls['incomepercentage'];
        // // tslint:disable-next-line: max-line-length
        // tslint:disable-next-line:max-line-length
        // if (this.dependantDetailsData.dependantQuestion === 'Y' && (!incomepercentage.value && !incomepercentage.touched) || (incomepercentage.touched && this.userInputDetail.sliderIncomePercentageConfig.unselectedByDefault)) {
        //   incomepercentage.setErrors({ notValid: true });
        // } else {
        //   incomepercentage.setErrors(null);
        // }
      }
      if (this.selectedProduct.productCode === 'H') {
        // const termplan = group.controls['termplan'];
        // const termmonth = group.controls['termmonth'];
        const incomematurity = group.controls['incomematurity'];
        const fundValue = group.controls['fundValue'];
        const advance = group.controls['advance'];
        // const frequency = group.controls['frequency'];

        // if(termplan.value !== 25 && (this.userInputDetail.sliderTermConfig.unselectedByDefault === true ||
        //   this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault === true )) {
        //   termplan.setErrors({ termPlanFTRPError: true });
        //   // this.termPlanFTRPErrorflag = true;
        // } else {
        //   termplan.setErrors(null);
        //   this.termPlanFTRPErrorflag = false;
        // }
        // if (termplan.value !== 25 && !termplan.touched) {
        //   termplan.setErrors({ notValid: true });
        // } else {
        //   termplan.setErrors(null);
        // }
        // if (termplan.value !== 25 && this.userInputDetail.sliderTermConfig.unselectedByDefault || this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault) {
        //   // termplan.setErrors({ notValid: true });
        //   this.FTRPTermSliderErrorVisible = true;
        // } else {
        //   this.FTRPTermSliderErrorVisible = false;
        // }
        // if (termplan.value !== 25 && termmonth.value ===0 && !termmonth.touched) {
        //   termmonth.setErrors({ notValid: true });
        // } else {
        //   termmonth.setErrors(null);
        // }
        if (incomematurity.value === 'M' && fundValue.value !== '' && fundValue.value !== null && parseFloat(fundValue.value) === 0) {
          fundValue.setErrors({ invalidMaturity: true });
        }
        if (incomematurity.value === 'Y' && fundValue.value !== '' && fundValue.value !== null && parseFloat(fundValue.value) === 0) {
          fundValue.setErrors(null);
          advance.setErrors(null);
          // frequency.setErrors(null);
        } else {
          if (!advance.value) {
            advance.setErrors({ required: true });
          }
          // if (!frequency.value && !frequency.disabled) {
          //   frequency.setErrors({ required: true });
          // }
        }
      }
      if (this.selectedProduct.productCode === 'G') {
        const termmonth = group.controls['termmonth'];
        if (termmonth.errors.customMandatoryError) {
          termmonth.setErrors({ notValid: true });
        } else {
          termmonth.setErrors(null);
        }
      }
      // tslint:disable-next-line: max-line-length
      // if ((!taxfreelumpsum.value && !taxfreelumpsum.touched) || (taxfreelumpsum.touched && this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault)) {
      //   taxfreelumpsum.setErrors({ notValid: true });
      // } else {
      //   taxfreelumpsum.setErrors(null);
      // }
      // else if (control5.value !== '') {
      //   control5.setErrors(null);
      // }
      return;
    };
  }
  oncalculatedValue(value, mode?: string) {
    if (mode === 'primary') {
      this.taxFreeFund = (this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault) ? null : value;
    } else if (mode === 'secondary') {
      this.taxFreeFundSecondary = (this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault) ? null : value;
      if (this.fundingSource === 'B' && this.selectedProduct.productCode == 'C') {
        this.quoteForm.controls['fundValueTaxfree'].setValidators([]);
        this.quoteForm.controls['taxfreeRadioButton'].setValidators([]);

        this.quoteForm.controls['fundValueTaxfree'].updateValueAndValidity();
        this.quoteForm.controls['taxfreeRadioButton'].updateValueAndValidity();
      } else {

        this.quoteForm.controls['fundValueTaxfree'].setValidators([Validators.required]);
        this.quoteForm.controls['taxfreeRadioButton'].setValidators([Validators.required]);

        this.quoteForm.controls['fundValueTaxfree'].updateValueAndValidity();
        this.quoteForm.controls['taxfreeRadioButton'].updateValueAndValidity();

      }
    }
  }
  checkValidation() {

    const periodofincome = this.quoteForm.controls['periodofincome'];
    // for FTRP
    if (this.selectedProduct.productCode === 'H') {
      this.guaranteedPeriodErrorFlag = false;
      // const termplan = this.quoteForm.controls['termplan'];
      // const termmonth = this.quoteForm.controls['termmonth'];
      // if (termplan.value !== 25 && this.userInputDetail.sliderTermConfig.unselectedByDefault || this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault) {
      //   termplan.setErrors({ notValid: true });
      //   this.FTRPTermSliderErrorVisible = true;
      // } else {
      //   termplan.setErrors({ null });
      //   this.FTRPTermSliderErrorVisible = false;
      // }
      // if (this.userInputDetail.sliderTermConfig.unselectedByDefault) {
      //   termplan.setErrors({ notValid: true });
      // } else {
      //   termplan.setErrors(null);
      // }

      // if(termplan.value !== 25 && (this.userInputDetail.sliderTermConfig.unselectedByDefault === true ||
      //   this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault === true )) {
      //   termplan.setErrors({ termPlanFTRPError: true });
      //   this.termPlanFTRPErrorflag = true;
      // } else {
      //   termplan.setErrors(null);
      //   this.termPlanFTRPErrorflag = false;
      // }
      if (this.periodOfIncomeSliderVisibility && this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault) {
        periodofincome.setErrors({ notValid: true });
      } else {
        periodofincome.setErrors(null);
      }
    }

    // tslint:disable-next-line: max-line-length
    this.checkTaxfreeValidations();
    if (this.selectedProduct.productCode === 'C') {
      const incomepercentage = this.quoteForm.controls['incomepercentage'];
      const vpslider = this.quoteForm.controls['vpslider'];
      const pdofincome = this.quoteForm.controls['periodofincome'];
      // add control
      // tslint:disable-next-line: max-line-length
      if (this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault && !this.disableIncomeSlider) {
        periodofincome.setErrors({ notValid: true });
      } else if (!this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault && this.disableIncomeSlider) {
        periodofincome.setErrors(null);
      }
      if (this.userInputDetail.slidervpConfig.unselectedByDefault && !this.disableInvestmentSlider) {
        vpslider.setErrors({ notValid: true });
      } else if (!this.userInputDetail.slidervpConfig.unselectedByDefault && this.disableInvestmentSlider) {
        vpslider.setErrors(null);
      }
      if (this.userInputDetail.sliderIncomePercentageConfig.unselectedByDefault && !this.disableDependantIncomeSlider) {
        incomepercentage.setErrors({ notValid: true });
      } else {
        if ((this.disableIncomeSlider && incomepercentage.value === 0 && this.dependantDetailsData.dependantQuestion === 'Y'
          && !this.disableDependantIncomeSlider) ||
          (!this.disableIncomeSlider && pdofincome.value === 0 && this.dependantDetailsData.dependantQuestion === 'Y'
            && !this.disableDependantIncomeSlider && incomepercentage.value === 0)) {
          incomepercentage.setErrors({ zeroAmount: true });
        } else
          // if (!this.userInputDetail.sliderIncomePercentageConfig.unselectedByDefault && this.disableDependantIncomeSlider) {
          incomepercentage.setErrors(null);
        // for remove error
        // }
      }
    }
    if (this.selectedProduct.productCode === 'G' || this.selectedProduct.productCode === 'H') {
      if (this.userInputDetail.sliderTermConfig.unselectedByDefault &&
        !this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault) {
        this.sliderErrorVisible = true;
      } else {
        this.sliderErrorVisible = false;
      }
      const termmonth = this.quoteForm.controls['termmonth'];
      const termyear = this.quoteForm.controls['termyear'];
      if (this.userInputDetail.sliderTermConfig.unselectedByDefault) {
        termmonth.setErrors({ notValid: true });
      } else {
        termmonth.setErrors(null);
      }
      if (termmonth.valid) {
        if (this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault) {
          termmonth.setErrors({ notValid: true });
        } else {
          termmonth.setErrors(null);
        }
      }
    }
  }
  createTaxFreeLumpsum = () => {
    this.calculatedTaxFreeLumSum = [];
    if (this.quoteForm && this.quoteForm.controls['taxfreeRadioButton'] &&
      this.quoteForm.controls['taxfreeRadioButton'].value) {
      const taxfreeRadio = this.quoteForm.controls['taxfreeRadioButton'].value;
      this.calculatedTaxFreeLumSum.push({
        mode: 'primary',
        value: (taxfreeRadio === 'N') ? null :
          ((taxfreeRadio === 'P') ? this.taxFreeFund :
            (this.quoteForm.controls['fundValueTaxfree'] ?
              CurrencyFunctionalityService.convertCurrencyToNumber(this.quoteForm.controls['fundValueTaxfree'].value) : null)),
        perc: (taxfreeRadio === 'N') ? null :
          ((taxfreeRadio === 'P') ? (this.quoteForm.controls['taxfreelumpsum'] ?
            this.quoteForm.controls['taxfreelumpsum'].value : null) : this.taxfreePerc)
      });
    }
    if (this.multipleTaxfree || (this.fundingSource === 'B' && this.selectedProduct.productCode === 'C')) {
      if (this.quoteForm && this.quoteForm.controls['taxfreeRadioButtonSecondary'] &&
        this.quoteForm.controls['taxfreeRadioButtonSecondary'].value) {
        const taxfreeRadio = this.quoteForm.controls['taxfreeRadioButtonSecondary'].value;
        this.calculatedTaxFreeLumSum.push({
          mode: 'secondary',
          value: (taxfreeRadio === 'N') ? null :
            ((taxfreeRadio === 'P') ? this.taxFreeFundSecondary :
              (this.quoteForm.controls['fundValueTaxfreeSecondary'] ?
                CurrencyFunctionalityService.convertCurrencyToNumber(this.quoteForm.controls['fundValueTaxfreeSecondary'].value) : null)),
          perc: (taxfreeRadio === 'N') ? null :
            ((taxfreeRadio === 'P') ? (this.quoteForm.controls['taxfreelumpsumSecondary'] ?
              this.quoteForm.controls['taxfreelumpsumSecondary'].value : null) : this.taxfreePercSecondary)
        });
      }
    }
    // if (this.calculatedTaxFreeLumSum) {
    //   let taxFree = this.calculatedTaxFreeLumSum.filter((taxfree) => {
    //     return taxfree.mode === mode;
    //   });
    //   if (taxFree && taxFree.length > 0) {
    //     if (mode === 'primary') {
    //       taxFree[0].value = (this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault) ? null : value;
    //     } else if (mode === 'secondary') {
    //       taxFree[0].value = (this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault) ? null : value;
    //     }
    //   } else {
    //     this.calculatedTaxFreeLumSum.push({
    //       mode,
    //       value: null,
    //     perc: null
    //     });
    //   }
    // } else {
    //   this.calculatedTaxFreeLumSum = [];
    //   this.calculatedTaxFreeLumSum.push({
    //     mode,
    //     value: null,
    //     perc: null
    //   });
    // }
  }

  proceedAsNormal() {
    // Quote Mapping Starts
    this.checkValidation();
    this.createTaxFreeLumpsum();
    // Quote Mapping Ends
    this.resetErrorMessages();
    if (this.quoteForm.valid) {
      this.store.dispatch(new CardRefreshActions.RemoveCardRefreshval(0));
      this.store.dispatch(new CardRefreshActions.AddCardRefreshval({ setCardRefresh: true }));
      this.setQuoteType();
      this.loaderService.handleSpinnerFlag({ show: true, onlyBackgroundFlag: true, Message: '', opacity: .4 });
      if (this.mode === 'edit') {
        this.buttonService.handleButtonLoaderFlag({ flag: true });
      }
      this.loadingFlag = true;
      this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
      // tslint:disable-next-line: max-line-length
      this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation(
        { ...this.quoteForm.value, calculatedTaxFreeLumSum: this.calculatedTaxFreeLumSum, selectedQuoteType: this.selectedQuoteType }
      ));
      this.quoteRefNoStore = this.store.select(STORE_VAL.ref_no);
      this.quoteRefNoStore.subscribe((val) => {
        if (val.length > 0) {
          this.globalIndex = val[0]['quoteNumberFlag'];
        }
      });
      if (this.mode === 'view') {
        this.quoteCalculationStore = this.store.select(STORE_VAL.quote_calculation);
        this.quoteCalculationStore.subscribe(res => {
          if (res.length > 0) {
            this.quoteresstore = res[0];
          }
        });
        // tslint:disable-next-line: max-line-length
        if (this.quoteresstore && (!this.quoteresstore.benefitVariants || this.quoteresstore.benefitVariants.length < this.userInputDetail.cardConfig.maxLimit)) {
          this.globalIndex = this.globalIndex + 1;
          this.store.dispatch(new RefNoActions.EditReferenceNumber(this.globalIndex));
          this.quoteDataCaptureService.postQuickQuoteValues(true, this.globalIndex).subscribe(res => {
            let cardCreated = true;
            if (res.lock) {
              this.isLocked = true;
              cardCreated = false;
              this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
              this.buttonService.handleButtonLoaderFlag({ flag: false });
              this.loadingFlag = false;
            } else {
              this.isLocked = false;
              this.addQuoteData(res);
            }
          },
            errr => {
              this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
              this.buttonService.handleButtonLoaderFlag({ flag: false });
              this.loadingFlag = false;
            });
        } else if (!this.quoteresstore) {
          const pensionAmount = this.yourPensionData.cedingFund ? this.yourPensionData.cedingFund : this.yourPensionData.totalSum;
          const val = (pensionAmount * (this.quoteForm.value ? this.quoteForm.value.taxfreelumpsum : 0)) / 100;
          this.store.dispatch(new ResQuoteCalcActions.RemoveQuoteCalculation(0));
          this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
          // tslint:disable-next-line:max-line-length
          this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation({ ...this.quoteForm.value, calculatedTaxFreeLumSum: this.calculatedTaxFreeLumSum, selectedQuoteType: this.selectedQuoteType }));
          this.quoteDataCaptureService.postQuickQuoteValues(true, 1).subscribe(res => {
            let cardCreated = true;
            if (res.lock) {
              this.isLocked = true;
              cardCreated = false;
              this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
              this.buttonService.handleButtonLoaderFlag({ flag: false });
              this.loadingFlag = false;
            } else {
              this.isLocked = false;
              this.addQuoteData(res);
            }
          },
            errr => {
              this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
              this.buttonService.handleButtonLoaderFlag({ flag: false });
              this.loadingFlag = false;
            });
        } else {
          // alert('Unable to add more cards');
          this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
          this.buttonService.handleButtonLoaderFlag({ flag: false });
          this.loadingFlag = false;
          this.errormessage = this.contentData.cardLimitExceededMessage;
        }
      } else if (this.mode === 'edit') {
        this.quoteDataCaptureService.editQuickQuoteValues(true, this.selectedCardNumber).subscribe(res => {
          let cardCreated = true;
          if (res.lock) {
            this.isLocked = true;
            cardCreated = false;
            this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
            this.buttonService.handleButtonLoaderFlag({ flag: false });
            this.loadingFlag = false;
          } else {
            this.isLocked = false;
            this.addQuoteData(res);
          }
        },
          errr => {
            this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
            this.buttonService.handleButtonLoaderFlag({ flag: false });
            this.loadingFlag = false;
          });
      }

    } else {
      FormValidationsService.validateAllFormFields(this.quoteForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      });
    }
  }
  checkCounter() {
    if (this.quickQuoteObjRes) {
      return this.quickQuoteObjRes['aceCalCounter'];
    } else {
      return 0;
    }
  }
  gotoNextPage = () => {
    /** Step 1 : callback to backend and fetch the ACECalCounter */
    this.ACECalCounter = this.checkCounter();
    //console.log('quickQuoteObjRes => ', this.quickQuoteObjRes);
    //console.log('this.ACECalCounter =', this.ACECalCounter);
    /** Step 2 : Replace this with the actual call to backend to fetch this attribute  */
    if (this.ACECalCounter > 5 && this.ACECalCounter <= 15) {
      // this.randomNumber = 7;
      /** Step 3 : add js random() here to trigger the below request randomly between the range >6 && <=15, per requirement  */
      if (this.ACECalCounter === this.randomNumber) {
        this.recaptchaCheckCall();
        /** Step 4 add a listener which after completion would execute the below */
        this.grecaptchaResponseSubject.subscribe((res: string) => {
          //console.log('grecaptchaResponseSubject  = ', res);
          if (res || (res !== null) || (res !== undefined)) {
            /** Step 5 : post the grecaptchaResponseKey to the backend service */
            this.googleRecaptchaV2Service.getGoogleRecaptchaResponse(res).subscribe({
              next: res => {
                //console.log(res);
                this.humanFlag = res;
                /** Step 6 : execute the else block as normal as it verified as human. */
                if (this.humanFlag) {
                  this.proceedAsNormal();
                } else {
                  /** Step 7 : return false and not proceed as it verified as Not human. */
                  return false;
                }
              },
              error: error => console.error('There was an error!', error)
            });
            /** Rare case scenario - This else block will execute if we do not get any response from Google API as a response  */
          } else {
            return false;
          }
        });
        /** End of subject block */
      } else {
        this.proceedAsNormal();
      }
      /** Step 7 : else block when the ACECalCounter range is from 1-6 , executes as normal. */
    } else {
      this.proceedAsNormal();
    }
    /** End of gotoNext block  */

  }
  /** End of gotoNext */

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }
  updateHeaderAndLoadData = () => {
    // if (this.contentData) {
    //   if(this.productChoiceData.productName === 'Fixed Term Retirement Plan') {
    //     this.productChoiceData.productName = this.CMSData.stringGroup_ProductOptionsFtrpTitle;
    //     const headerType = '<strong>' + this.productChoiceData.productName + '</strong>';
    //     this.contentData.header = this.contentData.header.replace('{}', headerType);
    //   }
    //   if(this.productChoiceData.productName === 'Pension Annuity') {
    //     this.productChoiceData.productName = this.CMSData.stringGroup_ProductOptionsPensionAnnuityTitle;
    //     const headerType = '<strong>' + this.productChoiceData.productName + '</strong>';
    //     this.contentData.header = this.contentData.header.replace('{}', headerType);
    //   }
    //   if(this.productChoiceData.productName === 'Cash Out Retirement Plan') {
    //     this.productChoiceData.productName = this.CMSData.stringGroup_ProductOptionsCorpTitle;
    //     const headerType = '<strong>' + this.productChoiceData.productName + '</strong>';
    //     this.contentData.header = this.contentData.header.replace('{}', headerType);
    //   } else {
    //     const headerType = '<strong>' + this.productChoiceData.productName + '</strong>';
    //     this.contentData.header = this.contentData.header.replace('{}', headerType);
    //   }
    // }
    if (this.contentData) {
      const headerType = '<strong>' + this.productChoiceData?.productName + '</strong>';
      this.header = this.contentData.headerPart1 + headerType + this.contentData.headerPart2;
    }
    if (this.productCms && this.productCms.products) {
      this.selectedProduct = this.productCms.products.filter((product, index) => {
        return (product.productCode === this.productChoiceData.selectedProduct);
      });
      if (this.selectedProduct.length > 0) {
        this.selectedProduct = this.selectedProduct[0];
        // 1320 changes added by msp7317
        this.showTaxfreeSlider = false;
        this.showTaxfreeInput = false;
        this.showSecondTaxfreeSlider = false;
        this.showSecondTaxfreeInput = false;
        // end
        if (this.selectedProduct.productCode === 'C') {
          this.userFormDataPensionAnnuity();
        } else if (this.selectedProduct.productCode === 'H') {
          this.userFormDataFTRP();
          // this.changeToolTipText();
        } else if (this.selectedProduct.productCode === 'G') {
          this.userFormDataCORP();
        }
        if (this.taxfreePerc) {
          this.userInputDetail.taxfreeValueConfig.titleValue = this.taxfreePerc.toFixed(3).toString();
          //format the currency before binding
          this.userInputDetail.taxfreeValueConfig.value = this.formatCurrency(this.taxFreeFund.toString());
        }
        if (this.taxfreePercSecondary) {
          this.userInputDetail.secondaryTaxfreeValueConfig.titleValue = this.taxfreePercSecondary.toFixed(3).toString();
          //format the currency before binding
          this.userInputDetail.secondaryTaxfreeValueConfig.value = this.formatCurrency(this.taxFreeFundSecondary.toString());
        }
      }
    }
  }

  toggleSlider = (data, control) => {
    switch (control) {
      case 'income':
        if (data.code === 'F') {
          this.showIncomeSlider = true;
        } else {
          this.showIncomeSlider = false;
        }
        break;
      case 'taxfree':
        this.showTaxfreeSlider = false;
        this.showTaxfreeInput = false;
        if (data.code === 'P') {
          this.showTaxfreeSlider = true;
        } else if (data.code === 'A') {
          this.showTaxfreeInput = true;
          // defect 6437
          if(this.userInputDetail && this.userInputDetail.taxfreeValueConfig) {
            this.userInputDetail.taxfreeValueConfig.value = this.formatCurrency(this.userInputDetail.taxfreeValueConfig.value)
          }
        }
        break;
      case 'taxfreeSecond':
        this.showSecondTaxfreeSlider = false;
        this.showSecondTaxfreeInput = false;
        if (data.code === 'P') {
          this.showSecondTaxfreeSlider = true;
        } else if (data.code === 'A') {
          // defect 6437
          if(this.userInputDetail && this.userInputDetail.secondaryTaxfreeValueConfig) {
            this.userInputDetail.secondaryTaxfreeValueConfig.value = this.formatCurrency(this.userInputDetail.secondaryTaxfreeValueConfig.value)
          }
          this.showSecondTaxfreeInput = true;
        }
        break;
    }
  }

  toggleValueProtection = (data) => {
    this.showWarningforDependentIncome = false;
    this.showWarningforGuaranteedIncome = false;
    this.enableDependantTooltip = (data && data.code === 'Inc') ? true : false;
    this.vpWarningFlag = (data && data.code === 'Ann') ? true : false;
    if (data && data.code === 'Ann') {
      this.showWarningValueProtection = false;
      if (this.dependantDetailsData && (this.dependantDetailsData.dependantQuestion === 'Y')) {
        this.resetSliderStatusValues(false, true, true, 25, 0, 0, true, { Ques: 'Y', Selection: 'Ann' });
      } else {
        this.resetSliderStatusValues(false, true, true, 25, 0, 0, true, { Ques: 'N', Selection: 'Ann' });
      }
    } else

      if (data && data.code === 'Inc') {
        this.showWarningValueProtection = false;
        if (this.dependantDetailsData && (this.dependantDetailsData.dependantQuestion === 'Y')) {
          this.resetSliderStatusValues(true, false, false, 25, 0, 0, true, { Ques: 'Y', Selection: 'Inc' });
        } else {
          this.resetSliderStatusValues(true, false, true, 25, 0, 0, true, { Ques: 'N', Selection: 'Inc' });
        }
      } else

        if (data && data.code === 'Ne') {
          if (this.dependantDetailsData && (this.dependantDetailsData.dependantQuestion === 'Y')) {
            this.showWarningValueProtection = true;
            this.hideValueProtectionWarningMessage = true;
            //console.log('2 hideValueProtectionWarningMessage  ', this.hideValueProtectionWarningMessage);
            this.resetSliderStatusValues(true, true, true, 25, 0, 0, true, { Ques: 'Y', Selection: 'Ne' });
          } else {
            this.resetSliderStatusValues(true, true, true, 25, 0, 0, true, { Ques: 'N', Selection: 'Ne' });
          }
        }
  }

  resetSliderStatusValues(vpStatus, incStatus, incPerStatus, vpValue, incValue, incPerValue, isDefaultValues, ModeObject) {
    this.disableInvestmentSlider = vpStatus;
    this.disableIncomeSlider = incStatus;
    this.disableDependantIncomeSlider = incPerStatus;

    if (ModeObject.Ques === 'Y') {
      this.userInputDetail.slidervpConfig.infoIconData.disabledInfoIconTextVisibility = true;
      this.userInputDetail.sliderIncomePercentageConfig.infoIconData.disabledInfoIconTextVisibility = false;
    } else
      if (ModeObject.Ques === 'N') {
        this.userInputDetail.sliderIncomePercentageConfig.infoIconData.disabledInfoIconTextVisibility = true;
        this.userInputDetail.slidervpConfig.infoIconData.disabledInfoIconTextVisibility = false;
      }
    // this.userInputDetail.sliderperiodOfIncomeConfig.infoIconData.disabledInfoIconTextVisibility = !incStatus;
    // this.userInputDetail.sliderIncomePercentageConfig.infoIconData.disabledInfoIconTextVisibility = !incPerStatus;

    this.quoteForm.controls.vpslider.setValue(vpValue);
    this.quoteForm.controls.periodofincome.setValue(incValue);
    this.quoteForm.controls.incomepercentage.setValue(incPerValue);

    if (!isDefaultValues) {
      this.userInputDetail.slidervpConfig.unselectedByDefault = vpStatus;
      this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = incStatus;
      this.userInputDetail.sliderIncomePercentageConfig.unselectedByDefault = incPerStatus;
    } else
      if (isDefaultValues) {
        this.userInputDetail.slidervpConfig.unselectedByDefault = true;
        this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = true;
        this.userInputDetail.sliderIncomePercentageConfig.unselectedByDefault = true;
      }
  }

  enableEditMode = () => {
      this.quoteCalculationStore = this.store.select(STORE_VAL.quote_calculation);
      this.quoteCalculationStore.subscribe(res => {
        if (res.length > 0) {
          this.quoteresstore = res[0];
        }
      });
      if (this.quoteresstore) {
        const cardSelected = this.quoteresstore.benefitVariants.filter(req => req.cardNumber === this.selectedCardNumber);
        this.loadSelectedCard(cardSelected);
        this.userInputDetail.buttonAddCalculationConfig.label = this.contentData.doneEditingBtn;
        this.userInputDetail.buttonAddCalculationConfig.showIcon = false;
      }
  }

  enableViewMode = () => {
    this.userInputDetail.buttonAddCalculationConfig.label = this.contentData.calculateButton;
    this.userInputDetail.buttonAddCalculationConfig.showIcon = true;
    this.editFlag = !this.editFlag;
    this.mode = 'view';
  }
  loadSelectedCard(card) {

    this.resetErrorMessages();
    if (card && card.length > 0) {
      const cardquickQuote = card[0].quickQuoteModel ? card[0].quickQuoteModel : [];
      let cardbenefitBasis = card[0].benefitBasisModel[0] ? card[0].benefitBasisModel[0] : [];
      let cardquoteBasis = card[0].quoteBasisModel ? card[0].quoteBasisModel : [];
      // capturing start date input value from backend response
      if (cardquoteBasis.commencementDate !== null) {
        const tempDate = cardquoteBasis.commencementDate.toString();
        // cardquoteBasis.commencementDate = tempDate.indexOf('/') > -1 ? (tempDate.split('/').join(' / ')) : tempDate;
        let cDate = tempDate.indexOf('/') > -1 ? (tempDate.split('/').join(' / ')) : tempDate;
        cardquoteBasis = {...cardquoteBasis , commencementDate: cDate};
      }
      // capturing start date button value from backend response
      if (cardquoteBasis.startDateType !== null) {
        // cardquoteBasis.startDateType = cardquoteBasis.startDateType === 'As Soon As Possible' ? 'A' : '';
        let sDate = cardquoteBasis.startDateType === 'As Soon As Possible' ? 'A' : '';
        cardquoteBasis = {...cardquoteBasis , startDateType: sDate};
      }
      if (cardbenefitBasis.escalationRate && cardbenefitBasis.escalationRate.toString().includes('%')) {
        // cardbenefitBasis.escalationRate = cardbenefitBasis.escalationRate.toString().replace('%', '');
        let escalRate = cardbenefitBasis.escalationRate.toString().replace('%', '');
        cardbenefitBasis = {...cardbenefitBasis , escalationRate: escalRate};
      }
      if (this.selectedProduct.productCode === 'C') {
        // this.quoteForm.get('increasedincome').setValue(isNaN(cardbenefitBasis.escalationType) ?
        //   cardbenefitBasis.escalationType : 'F');
        // this.quoteForm.get('increasedincomeslider').setValue((cardbenefitBasis.escalationType !== 'R' &&
        //   cardbenefitBasis.escalationType !== 'N') ?
        //   cardbenefitBasis.escalationRate.toString() : null);
        // this.quoteForm.get('advance').setValue(cardquoteBasis.paymentAdvance);
        // this.quoteForm.get('frequency').setValue(cardquoteBasis.paymentFrequency);
        // this.quoteForm.get('valueprotection').setValue(cardbenefitBasis.vpIndicator);
        // this.quoteForm.get('periodofincome').setValue(cardbenefitBasis.guaranteedTerm);
        // this.quoteForm.get('vpslider').setValue(cardbenefitBasis.vpPercentage);
        // this.quoteForm.get('productType').setValue('C');
        // this.quoteForm.get('incomepercentage').setValue(cardbenefitBasis.secondLifePensionPercentageType === 'N' ?
        //   // tslint:disable-next-line:radix
        //   0 : parseInt(cardbenefitBasis.secondLifePensionPercentage));
        this.quoteForm = this.fb.group({
          currentDate: [cardquoteBasis.startDateType],
          startDate: [cardquoteBasis.commencementDate],
          increasedincome: [isNaN(cardbenefitBasis.escalationType) ? cardbenefitBasis.escalationType : 'F', Validators.required],
          increasedincomeslider: [((cardbenefitBasis.escalationType !== 'R' && cardbenefitBasis.escalationType !== 'N') ?
            cardbenefitBasis.escalationRate.toString() : null), null],
          advance: [cardquoteBasis.paymentAdvance, Validators.required],
          frequency: [cardquoteBasis.paymentFrequency, Validators.required],
          valueprotection: [cardbenefitBasis.vpIndicator, Validators.required],
          periodofincome: [cardbenefitBasis.guaranteedTerm, Validators.required],
          incomepercentage:
            // doubt, ok
            [cardbenefitBasis.secondLifePensionPercentageType === 'N' ?
              0 : parseInt(cardbenefitBasis.secondLifePensionPercentage), Validators.required],
          taxfreelumpsum: [0, Validators.required],
          taxfreelumpsumSecondary: [0, Validators.required],
          taxfreeRadioButton: [null, Validators.required],
          taxfreeRadioButtonSecondary: [null, Validators.required],
          fundValueTaxfree: [0, Validators.required],
          fundValueTaxfreeSecondary: [0, Validators.required],
          // 1 'Ann' condition was there cardbenefitBasis.vpPercentage : 25
          vpslider: [cardbenefitBasis.vpPercentage, Validators.required],
          productType: 'C'
        });
        this.populateTaxFreeCash(cardbenefitBasis);
        this.setTaxfreeLabel();
        if (cardbenefitBasis.escalationType !== 'R' && cardbenefitBasis.escalationType !== 'N' && cardbenefitBasis.escalationType !== '') {
          this.showIncomeSlider = true;
        } else {
          this.showIncomeSlider = false;
        }
        if (this.dependantDetailsData && (this.dependantDetailsData.dependantQuestion === 'N')) {
          // this.userInputDetail.radioButtonvalueProtectionConfig.disabled = false;

          if (this.yourOptions && this.yourOptions.valueprotection) {
            this.quoteForm.controls['valueprotection'].setValue(cardbenefitBasis.vpIndicator);
            this.enableDependantTooltip = cardbenefitBasis.vpIndicator === 'Inc' ? true : false;
            this.vpWarningFlag = cardbenefitBasis.vpIndicator === 'Ann' ? true : false;
            if (cardbenefitBasis.vpIndicator === 'Ann') {
              this.resetSliderStatusValues(false, true, true, cardbenefitBasis.vpPercentage, 0, 0, false, { Ques: 'N', Selection: 'Ann' });
            } else if (cardbenefitBasis.vpIndicator === 'Inc') {
              // tslint:disable-next-line:max-line-length
              this.resetSliderStatusValues(true, false, true, 0, cardbenefitBasis.guaranteedTerm, 0, false, { Ques: 'N', Selection: 'Inc' });
            } else if (cardbenefitBasis.vpIndicator === 'Ne') {
              this.resetSliderStatusValues(true, true, true, 25, 0, 0, false, { Ques: 'N', Selection: 'Ne' });
            }
          } else {
            this.quoteForm.controls['valueprotection'].setValue(null);
            this.resetSliderStatusValues(true, true, true, 25, 0, 0, false, { Ques: 'N', Selection: 'De' });
            this.quoteForm.controls['valueprotection'].setValidators([Validators.required]);
            this.quoteForm.controls['valueprotection'].updateValueAndValidity();
          }
          // this.disableInvestmentSlider = true;
          // this.quoteForm.controls['periodofincome'].setValue(0);
          // this.quoteForm.controls['incomepercentage'].setValue(0);
        } else if (this.dependantDetailsData && (this.dependantDetailsData.dependantQuestion === 'Y')) {
          // 4
          if (this.yourOptions && this.yourOptions.valueprotection) {
            this.quoteForm.controls['valueprotection'].setValue(cardbenefitBasis.vpIndicator);
            this.enableDependantTooltip = cardbenefitBasis.vpIndicator === 'Inc' ? true : false;
            this.vpWarningFlag = cardbenefitBasis.vpIndicator === 'Ann' ? true : false;
            if (cardbenefitBasis.vpIndicator === 'Ann') {
              this.resetSliderStatusValues(false, true, true, cardbenefitBasis.vpPercentage, 0, 0, false, { Ques: 'Y', Selection: 'Ann' });
            } else if (cardbenefitBasis.vpIndicator === 'Inc') {
              // tslint:disable-next-line:max-line-length
              this.resetSliderStatusValues(true, false, false, 25, cardbenefitBasis.guaranteedTerm, cardbenefitBasis.secondLifePensionPercentageType === 'N' ? 0 : parseInt(cardbenefitBasis.secondLifePensionPercentage), false, { Ques: 'Y', Selection: 'Inc' });
              // update
            } else if (cardbenefitBasis.vpIndicator === 'Ne') {
              // tslint:disable-next-line:max-line-length
              this.resetSliderStatusValues(true, true, true, 25, 0, cardbenefitBasis.secondLifePensionPercentageType === 'N' ? 0 : parseInt(cardbenefitBasis.secondLifePensionPercentage), false, { Ques: 'Y', Selection: 'Ne' });
              // update
            }
          } else {
            // 5
            this.quoteForm.controls['valueprotection'].setValue(null);
            this.resetSliderStatusValues(true, true, true, 25, 0, 0, false, { Ques: 'Y', Selection: 'De' });
            this.quoteForm.controls['valueprotection'].clearValidators();
            this.quoteForm.controls['valueprotection'].updateValueAndValidity();
            // this.userInputDetail.radioButtonvalueProtectionConfig.disabled = true;
            // this.showInvSlider = false;
            // this.disableInvestmentSlider = false;
          }
        }
      } else if (this.selectedProduct.productCode === 'G') {
        this.quoteForm = this.fb.group({
          currentDate: [cardquoteBasis.startDateType],
          startDate: [cardquoteBasis.commencementDate],
          increasedincome: [isNaN(cardbenefitBasis.escalationType) ? cardbenefitBasis.escalationType : 'F', Validators.required],
          increasedincomeslider: [((cardbenefitBasis.escalationType !== 'R' && cardbenefitBasis.escalationType !== 'N') ?
            cardbenefitBasis.escalationRate.toString() : null), null],
          termyear: [cardquoteBasis.policyTerm, Validators.required],
          termmonth: [cardquoteBasis.policyTermMonths, Validators.required],
          advance: [cardquoteBasis.paymentAdvance, Validators.required],
          frequency: [cardquoteBasis.paymentFrequency, Validators.required],
          taxfreelumpsum: [0, [Validators.required, this.customValidator]],
          taxfreeRadioButton: [null, Validators.required],
          productType: 'G',
          fundValueTaxfree: [null, [Validators.required, this.customValidator]],
          taxfreeRadioButtonSecondary: [null, Validators.required],
          taxfreelumpsumSecondary: [0, [Validators.required, this.customValidator]],
          fundValueTaxfreeSecondary: [null, [Validators.required, this.customValidator]]
        });
        if (cardbenefitBasis.escalationType !== 'R' && cardbenefitBasis.escalationType !== 'N' && cardbenefitBasis.escalationType !== '') {
          this.showIncomeSlider = true;
        } else {
          this.showIncomeSlider = false;
        }
        this.populateTaxFreeCash(cardbenefitBasis);
        if (this.userInputDetail) {
          this.userInputDetail.sliderMonthlyTermConfig.currentValue = cardquoteBasis.policyTermMonths;
          this.userInputDetail.sliderTermConfig.currentValue = cardquoteBasis.policyTerm;
        }
      } else {
        // productCode === 'H'
        let questionOptions = this.userInputDetail.radioButtonFTRPFrequencyConfig.questionOptions;
        if (cardquoteBasis.policyTerm === 25) {
          this.resetFrequency(questionOptions, true);
          this.setFrequency({ currentValue: 0 }, questionOptions);
        } else {
          this.resetFrequency(questionOptions, false);
          this.setFrequency({ currentValue: cardquoteBasis.policyTermMonths }, questionOptions);
        }
        this.quoteForm = this.fb.group({
          currentDate: [cardquoteBasis.startDateType],
          startDate: [cardquoteBasis.commencementDate],
          termplan: [cardquoteBasis.policyTerm, this.customValidator],
          termmonth: [cardquoteBasis.policyTermMonths, this.customValidator],
          fundValue: [this.setPlayback(card.length > 0 ? card[0] : null, 'fundValue'), [Validators.required, this.customValidator]],
          incomematurity: [this.setPlayback(card.length > 0 ? card[0] : null, 'incomematurity'),
          [Validators.required, this.customValidator]],
          increasedincome: [isNaN(cardbenefitBasis.escalationType) ? cardbenefitBasis.escalationType : 'F', Validators.required],
          increasedincomeslider: [((cardbenefitBasis.escalationType !== 'R' && cardbenefitBasis.escalationType !== 'N') ?
            cardbenefitBasis.escalationRate.toString() : null), null],
          vpslider: [25],
          advance: [(cardbenefitBasis.annualIncome !== null && cardbenefitBasis.annualIncome.toString() === '0') ? 'A'
            : cardquoteBasis.paymentAdvance, Validators.required],
          frequency: [cardquoteBasis.paymentFrequency, Validators.required],
          valueprotection: [null],
          periodofincome: [0, [Validators.required, this.customValidator]],
          periodofincomequestion: [null, Validators.required],
          incomepercentage: [null],
          taxfreelumpsum: [0, [Validators.required, this.customValidator]],
          taxfreeRadioButton: [null, Validators.required],
          productType: 'H',
          fundValueTaxfree: [null, [Validators.required, this.customValidator]],
          taxfreeRadioButtonSecondary: [null, Validators.required],
          taxfreelumpsumSecondary: [0, [Validators.required, this.customValidator]],
          fundValueTaxfreeSecondary: [null, [Validators.required, this.customValidator]]
        });
        if (cardbenefitBasis.escalationType !== 'R' && cardbenefitBasis.escalationType !== 'N' && cardbenefitBasis.escalationType !== '') {
          this.showIncomeSlider = true;
        } else {
          this.showIncomeSlider = false;
        }
        this.populateTaxFreeCash(cardbenefitBasis);
        if (this.quoteForm.get('fundValue').value === 0 && this.quoteForm.get('incomematurity').value === 'Y') {
          this.userInputDetail.radioButtonPeriodOfIncomeConfig.questionOptions.forEach(val => {
            if (val.code === 'O') {
              val.disable = true;
            }
          });
          this.quoteForm.get('periodofincomequestion').setValue(cardbenefitBasis.guaranteedTermIndicator);
          this.userInputDetail.sliderperiodOfIncomeConfig.stepsArray = [
            { value: 1 },
            {
              value: cardquoteBasis.policyTerm ? cardquoteBasis.policyTerm :
                this.userInputDetail.sliderperiodOfIncomeConfig.currentValue
            }
          ];

          if (cardbenefitBasis.guaranteedTerm === cardquoteBasis.policyTerm) {
            this.quoteForm.get('periodofincome').setValue(cardbenefitBasis.guaranteedTerm);
            this.userInputDetail.sliderperiodOfIncomeConfig.currentValue = cardbenefitBasis.guaranteedTerm;
          } else {
            this.quoteForm.get('periodofincome').setValue(1);
            this.userInputDetail.sliderperiodOfIncomeConfig.currentValue = 1;
          }
        } else {
          this.userInputDetail.radioButtonPeriodOfIncomeConfig.questionOptions.forEach(val => {
            if (val.code === 'O') {
              val.disable = false;
            }
          });
          this.quoteForm.get('periodofincomequestion').setValue(cardbenefitBasis.guaranteedTermIndicator);
          this.userInputDetail.sliderperiodOfIncomeConfig.stepsArray = [];
          // --------------------
          if (cardbenefitBasis.guaranteedTermIndicator && (cardbenefitBasis.guaranteedTermIndicator === 'N') || (cardbenefitBasis.guaranteedTermIndicator === 'F')) {
            this.quoteForm.controls['periodofincome'].setValue(1);
            this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = true;
            // this.userInputDetail.sliderperiodOfIncomeConfig.currentValue = cardbenefitBasis.guaranteedTerm;
            this.quoteForm.controls['periodofincome'].disable();
            this.periodOfIncomeSliderVisibility = false;

          } else if (cardbenefitBasis.guaranteedTermIndicator && cardbenefitBasis.guaranteedTermIndicator === 'O') {
            this.quoteForm.controls['periodofincome'].enable();
            this.quoteForm.controls['periodofincome'].setValue(cardbenefitBasis.guaranteedTerm);
            this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = false;
            this.userInputDetail.sliderperiodOfIncomeConfig.currentValue = cardbenefitBasis.guaranteedTerm;
            this.periodOfIncomeSliderVisibility = true;
          }
          // this.utilService.refreshSlider();
          // --------------------
          // this.quoteForm.get('periodofincome').setValue(cardbenefitBasis.guaranteedTerm);
          // this.userInputDetail.sliderperiodOfIncomeConfig.currentValue = cardbenefitBasis.guaranteedTerm;
        }
        this.userInputDetail.fundValueConfig.value =
          CurrencyFunctionalityService.convertNumberToCurrency(this.quoteForm.get('fundValue').value
            ? this.quoteForm.get('fundValue').value : 0);
        this.userInputDetail.sliderperiodOfIncomeConfig.maxValue = cardquoteBasis.policyTerm ? cardquoteBasis.policyTerm :
          this.userInputDetail.sliderperiodOfIncomeConfig.currentValue;
        // this.utilService.refreshSlider();
        if ((cardbenefitBasis.annualIncome !== null && cardbenefitBasis.annualIncome.toString()) === '0'
          || (this.quoteForm.get('fundValue').value === 0 && this.quoteForm.get('incomematurity').value === 'Y')) {
          this.userInputDetail.radioButtonAdvanceFTRPConfig.disabled = true;
          this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = true;
        } else {
          this.userInputDetail.radioButtonAdvanceFTRPConfig.disabled = false;
          this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
        }
      }

      this.utilService.refreshToggleButton();
    }
  }
  setPlayback = (card, type) => {
    if (card) {
      let cardKey = null;
      let cardValue = null;
      let dataReturn;
      if (card.benefitBasisModel[0].annualIncome && card.quickQuoteModel.annuitantPension
        && card.quickQuoteModel.annuitantYearlyPension) {
        if (card.quoteBasisModel.paymentFrequency === 'M' || card.quoteBasisModel.paymentFrequency === 'Y' || card.quoteBasisModel.paymentFrequency === 'H' || card.quoteBasisModel.paymentFrequency === 'Q') {
          cardKey = this.contentData.yearlyIncomeCode;
          cardValue = card.quickQuoteModel.annuitantYearlyPension;
        }
      } else if (card.benefitBasisModel[0].annualIncome !== null && card.benefitBasisModel[0].annualIncome.toString() === '0') {
        if (card.quickQuoteModel.annuitantPension === 0) {
          cardKey = this.contentData.yearlyIncomeCode;
          cardValue = 0;
        }
      } else if (card.benefitBasisModel[0].maturityAmount && card.quickQuoteModel.annuitantMaturity) {
        if (card.benefitBasisModel[0].maturityAmount === card.quickQuoteModel.annuitantMaturity) {
          cardKey = this.contentData.maturityValueCode;
          cardValue = card.quickQuoteModel.annuitantMaturity;
        } else {
          cardKey = this.contentData.yearlyIncomeCode;
          cardValue = 0;
        }
      }
      if (type === 'incomematurity') {
        dataReturn = cardKey;
      } else if (type === 'fundValue') {
        dataReturn = cardValue;
      }
      return dataReturn;
    }
  }
  saveProgress(redirectAfterSave = false) {
    this.createTaxFreeLumpsum();
    this.saveFormValues();
    this.quoteDataCaptureService.postQuoteDataCapture(false).subscribe(res => {
      if (redirectAfterSave) {
        this.router.navigate(['/quote/your-saved-quotes']);
      }
    });
  }
  saveAfterLogout() {
    this.createTaxFreeLumpsum();
    this.saveFormValues();
    this.subscriptn = this.quoteDataCaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveAfterLogin() {
    this.createTaxFreeLumpsum();
    this.saveFormValues();
    this.subscriptn = this.quoteDataCaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully());
  }
  saveFormValues() {
    if (this.quoteForm && this.quoteForm.get('productType').value === 'H') {
      if (this.userInputDetail.sliderTermConfig.unselectedByDefault) {
        this.quoteForm.get('termplan') && this.quoteForm.get('termplan').setValue(null);
      }
      if (this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault) {
        this.quoteForm.get('guaranteedTerm') && this.quoteForm.get('guaranteedTerm').setValue(null);
      }
      if (this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault) {
        this.quoteForm.get('taxfreelumpsum') && this.quoteForm.get('taxfreelumpsum').setValue(null);
      }
    } else if (this.quoteForm && this.quoteForm.get('productType').value === 'C') {
      if (this.userInputDetail.sliderIncomePercentageConfig.unselectedByDefault) {
        this.quoteForm.get('incomepercentage') && this.quoteForm.get('incomepercentage').setValue(null);
      }
      if (this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault) {
        this.quoteForm.get('periodofincome') && this.quoteForm.get('periodofincome').setValue(null);
      }
      if (this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault) {
        this.quoteForm.get('taxfreelumpsum') && this.quoteForm.get('taxfreelumpsum').setValue(null);
      }
      if (this.userInputDetail.slidervpConfig.unselectedByDefault) {
        this.quoteForm.get('vpslider') && this.quoteForm.get('vpslider').setValue(null);
      }
    } else if (this.quoteForm && this.quoteForm.get('productType').value === 'G') {
      if (this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault) {
        this.quoteForm.get('termmonth') && this.quoteForm.get('termmonth').setValue(null);
      }
      if (this.userInputDetail.sliderTermConfig.unselectedByDefault) {
        this.quoteForm.get('termyear') && this.quoteForm.get('termyear').setValue(null);
      }
      if (this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault) {
        this.quoteForm.get('taxfreelumpsum') && this.quoteForm.get('taxfreelumpsum').setValue(null);
      }
    }
    this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
    // tslint:disable-next-line: max-line-length
    this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation(
      { ...this.quoteForm.value, calculatedTaxFreeLumSum: this.calculatedTaxFreeLumSum }
    ));
  }
  OnBackClick() {
    if (this.quoteresstore && this.quoteresstore.benefitVariants &&
      this.quoteresstore.benefitVariants.length > 0 && this.referenceNumber) {
      this.referenceNumber = {...this.referenceNumber, isRefreshCard: true};
      const data = this.referenceNumber;
      this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
      this.store.dispatch(new RefNoActions.AddReferenceNumber(data));
    }
    this.resetSliderToUnselected();
    if (!this.calculatedTaxFreeLumSum) {
      this.createTaxFreeLumpsum();
    }
    if (this.mode === 'edit') {
      this.enableViewMode();
    }
    this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
    // tslint:disable-next-line: max-line-length
    this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation(
      { ...this.quoteForm.value, calculatedTaxFreeLumSum: this.calculatedTaxFreeLumSum }
    ));
  }
  changeScrollParams(value) {
    if (value) {
      let questionOptions = this.userInputDetail.radioButtonFTRPFrequencyConfig.questionOptions;
      if (value.controlName && value.controlName === 'termplan') {
        if (value.currentValue === 25) {
          // Value ?
          // this.userInputDetail.sliderMonthlyTermConfig.value = 0;
          this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault = false;
          // this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
          this.quoteForm.controls['termmonth'].setValue(0);
          // this.quoteForm.controls['termmonth'].markAsUntouched();
          if (!(this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'Y') && this.fundAmount === 0)) {
            this.resetFrequency(questionOptions, true);
            this.setFrequency({ currentValue: 0 }, questionOptions);
          }
        } else {
          if (this.disableMonthSlider) {
            if (!(this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'Y') && this.fundAmount === 0)) {
              this.resetFrequency(questionOptions, false);
            }
            questionOptions.forEach((val) => {
              val.disable = false;
            });
          }
          this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
          this.disableMonthSlider = false;
        }
        this.userInputDetail.sliderTermConfig.unselectedByDefault = false;
        if (this.userInputDetail.sliderperiodOfIncomeConfig.maxValue !== value.currentValue) {
          this.userInputDetail.sliderperiodOfIncomeConfig.maxValue = value.currentValue;
          this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = true;
          if (this.quoteForm) {
            if (this.quoteForm.controls['fundValue'].value === '0' &&
              this.quoteForm.controls['incomematurity'].value === 'Y') {
              this.userInputDetail.sliderperiodOfIncomeConfig.stepsArray = [
                { value: 1 },
                { value: value.currentValue }
              ];
            } else {
              this.userInputDetail.sliderperiodOfIncomeConfig.stepsArray = [];
            }
            if (this.quoteForm.controls['periodofincome']) {
              this.quoteForm.controls['periodofincome'].setValue(0);
              this.quoteForm.controls['periodofincome'].markAsUntouched();
              this.periodOfIncomeSliderVisibility = false;
            }
            if (this.quoteForm.controls['periodofincomequestion']) {
              this.quoteForm.controls['periodofincomequestion'].setValue('F');
              this.quoteForm.controls['periodofincomequestion'].markAsTouched();
            }
          }
        }
        if (!(this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'Y') && this.fundAmount === 0)) {
          this.quoteForm.controls['frequency'].markAsUntouched();
        }
        // value.unselectedByDefault = false;
        this.utilService.refreshSlider();
        // } else if (value.controlName && value.controlName === 'periodofincome') {

        // ----------------------------------------------------------------------------------------------------
        // ----------------------------------------------------------------------------------------------------

      } else if (value.controlName && value.controlName === 'termmonth') {
        if (this.quoteForm.controls['periodofincome']) {
          this.quoteForm.controls['periodofincome'].setValue(0);
          this.quoteForm.controls['periodofincome'].markAsUntouched();
          this.periodOfIncomeSliderVisibility = false;
        }
        if (this.quoteForm.controls['periodofincomequestion']) {
          this.quoteForm.controls['periodofincomequestion'].setValue('F');
          this.quoteForm.controls['periodofincomequestion'].markAsTouched();
        }
        this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = true;

        if (!(this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'Y') && this.fundAmount === 0)) {
          this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
          this.resetFrequency(questionOptions, false);
          this.setFrequency(value, questionOptions);
          this.quoteForm.controls['frequency'].markAsUntouched();
        }

      }
      else if (value.controlName) {
        // this.quoteForm.setValidators(this.customValidator());
        value.unselectedByDefault = false;
        this.utilService.refreshSlider();
      }
      value.unselectedByDefault = false;
      if (this.userInputDetail.sliderTermConfig.unselectedByDefault &&
        !this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault) {
        this.sliderErrorVisible = true;
      } else {
        this.sliderErrorVisible = false;
      }
      this.utilService.refreshSlider();
      if (!(this.quoteForm && (this.quoteForm.controls?.['incomematurity']?.value === 'Y') && this.fundAmount === 0)) {
        this.utilService.refreshToggleButton();
      }
    }
    // show warning message for guaranteed income slider
    if (this.quoteForm.controls.incomepercentage && this.quoteForm.controls.periodofincome) {
      if (this.quoteForm.value.periodofincome === 0 && this.quoteForm.value.incomepercentage > 0) {
        this.showWarningforGuaranteedIncome = true;
      } else {
        this.showWarningforGuaranteedIncome = false;
      }
    } else {
      this.showWarningforGuaranteedIncome = false;
    }

    /// show warning message for Dependent  slider
    if (this.quoteForm.controls.incomepercentage && this.quoteForm.controls.periodofincome) {
      if (this.quoteForm.value.incomepercentage === 0 && this.quoteForm.value.periodofincome > 0) {
        this.showWarningforDependentIncome = this.dependantDetailsData.dependantQuestion === 'Y' ? true : false;
      } else {
        this.showWarningforDependentIncome = false;
      }
    } else {
      this.showWarningforDependentIncome = false;
    }

  }

  // --------------------------------------------------------------------------------------------
  resetFrequency = (questionOptions, sliderFlag) => {
    this.disableMonthSlider = sliderFlag;
    this.userInputDetail.sliderMonthlyFTRPTermConfig.unselectedByDefault = !sliderFlag;
    this.quoteForm.controls['frequency'].setValue(null);
    this.quoteForm.controls['frequency'].setValidators([Validators.required]);
    questionOptions.forEach((val) => {
      val.disable = true;
    });
    this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = true;
  }

  setFrequency = (value, questionOptions) => {
    switch (value.currentValue) {
      case 0: {
        this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
        questionOptions.forEach((val) => {
          val.disable = false;
        });
        break;
      }
      case 3:
      case 9: {
        questionOptions.forEach((val) => {
          if (val.code === 'M' || val.code === 'Q') {
            this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
            val.disable = false;
          }
        });
        break;
      }
      case 6: {
        questionOptions.forEach((val) => {
          if (val.code !== 'Y') {
            this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
            val.disable = false;
          }
        });
        break;
      }
      default: {
        questionOptions.forEach((val) => {
          if (val.code === 'M') {
            this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
            val.disable = false;
          }
        });
        break;
      }
    }
  }
  // --------------------------------------------------------------------------------------------

  currencyChangeHandler(val) {
    this.fundAmount = CurrencyFunctionalityService.convertCurrencyToNumber(val);
    this.userInputDetail.sliderperiodOfIncomeConfig.stepsArray = [];
    if (this.quoteForm && this.quoteForm.controls['frequency']) {
      this.quoteForm.controls['frequency'].setValidators([Validators.required]);
      this.quoteForm.controls['frequency'].updateValueAndValidity();
    }
    // const periodofincomequestion = this.quoteForm.controls['periodofincomequestion'];
    if (this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'Y') && this.fundAmount === 0 && val !== '') {
      this.quoteForm.controls['frequency'].clearValidators();
      this.quoteForm.controls['frequency'].updateValueAndValidity();
      this.userInputDetail.radioButtonAdvanceFTRPConfig.disabled = true;
      this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = true;
      this.quoteForm.controls['frequency'].markAsUntouched();
      this.quoteForm.controls['frequency'].markAsUntouched();
      this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = true;
      this.userInputDetail.sliderperiodOfIncomeConfig.stepsArray = [
        { value: 1 },
        { value: this.quoteForm.controls['termplan'].value }
      ];

      this.quoteForm.controls['periodofincome'].setValue(1);
      this.quoteForm.controls['periodofincome'].markAsUntouched();
      this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = true;
      this.periodOfIncomeSliderVisibility = false;
      this.quoteForm.controls['periodofincomequestion'].setValue('F');
      this.quoteForm.controls['periodofincomequestion'].markAsTouched();
      this.guaranteedPeriodErrorFlag = true;
      this.userInputDetail.radioButtonPeriodOfIncomeConfig.questionOptions.forEach(val => {
        if (val.code === 'O') {
          val.disable = true;
        }
      });
      this.userInputDetail.sliderperiodOfIncomeConfig.currentValue = 1;
    } else if (this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'M') && this.fundAmount === 0 && val !== '') {
      // DTC-1219 New requirement : Reset Guarantee Options to Whole Term
      this.resetGuaranteedPeriod();
      // this.userInputDetail.radioButtonAdvanceConfig.disabled = true;
      this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
      this.quoteForm.controls['frequency'].markAsUntouched();
      this.userInputDetail.radioButtonPeriodOfIncomeConfig.questionOptions.forEach(val => {
        if (val.code === 'O') {
          val.disable = false;
        }
      });
      this.guaranteedPeriodErrorFlag = false;
    } else {
      this.userInputDetail.radioButtonPeriodOfIncomeConfig.questionOptions.forEach(val => {
        if (val.code === 'O') {
          val.disable = false;
        }
      });
      this.guaranteedPeriodErrorFlag = false;
      this.userInputDetail.radioButtonAdvanceFTRPConfig.disabled = false;
      this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
      this.quoteForm.controls['frequency'].markAsUntouched();
    }
    this.ACEErrorString = null;
    this.utilService.refreshToggleButton();
    this.utilService.refreshSlider();
    // this.currencyValueChanged.emit(true);
  }

  toggleMaturity() {
    // DTC-1219 New requirement : Reset Guarantee Options to Whole Term
    this.resetGuaranteedPeriod();
    if (this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'Y') &&
      (this.quoteForm.controls['fundValue'].value !== '' &&
        this.quoteForm.controls['fundValue'].value !== null &&
        parseInt(this.quoteForm.controls['fundValue'].value) === 0)) {
      this.userInputDetail.radioButtonAdvanceFTRPConfig.disabled = true;
      this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = true;
      this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = true;
      this.userInputDetail.sliderperiodOfIncomeConfig.stepsArray = [
        { value: 1 },
        { value: this.quoteForm.controls['termplan'].value }
      ];
      if (this.quoteForm.controls['periodofincome']) {
        this.quoteForm.controls['periodofincome'].setValue(0);
        this.quoteForm.controls['periodofincome'].markAsUntouched();
      }
    } else if (this.quoteForm && (this.quoteForm.controls['incomematurity'].value === 'M') &&
      (this.quoteForm.controls['fundValue'].value !== '' &&
        this.quoteForm.controls['fundValue'].value !== null &&
        parseInt(this.quoteForm.controls['fundValue'].value) === 0)) {
      this.userInputDetail.radioButtonAdvanceFTRPConfig.disabled = false;
      this.userInputDetail.radioButtonFTRPFrequencyConfig.disabled = false;
      this.userInputDetail.sliderperiodOfIncomeConfig.stepsArray = [];
    } else {
      this.userInputDetail.sliderperiodOfIncomeConfig.stepsArray = [];
    }
    // this.quoteForm.controls['fundValue'].setValue('');
    // Don't make it ==== it should be ==
    if (this.quoteForm.controls['fundValue'].value === 0) {
      this.currencyChangeHandler(this.quoteForm.controls['fundValue'].value);
    }
    this.ACEErrorString = null;
    this.utilService.refreshToggleButton();
    this.utilService.refreshSlider();
  }
  togglePeriodOfIncome(value) {
    if (value.code && (value.code === 'N') || (value.code === 'F')) {
      this.quoteForm.controls['periodofincome'].setValue(0);
      this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault = true;
      this.quoteForm.controls['periodofincome'].disable();
      this.periodOfIncomeSliderVisibility = false;
    } else if (value.code && value.code === 'O') {
      this.quoteForm.controls['periodofincome'].enable();
      this.quoteForm.controls['periodofincome'].setValue(0);
      this.periodOfIncomeSliderVisibility = true;
    }
    this.utilService.refreshSlider();
  }

  formatError(errorString: string): string {
    let formattedErrorString = errorString.substr(errorString.indexOf(' ') + 1, errorString.length);
    this.ACEErrorString = formattedErrorString;
    //console.log('formatError called ', this.ACEErrorString);
    return this.ACEErrorString;
  }
  // changeToolTipText = () => {
  //   if (this.userInputDetail) {
  //     // tslint:disable-next-line:max-line-length
  //     this.userInputDetail.sliderperiodOfIncomeConfig.infoIconData.content = this.userInputDetail.sliderperiodOfIncomeConfig.infoIconData.contentFTRP;
  //   }
  // }
  resetErrorMessages() {
    this.errormessage = '';
    this.ACEErrorString = '';
  }

  goToDependatsPageYOC() {
    this.resetSliderToUnselected();
    this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
    // tslint:disable-next-line: max-line-length
    this.store.dispatch(new ReqQuoteCalcActions.AddReqQuoteCalculation(
      { ...this.quoteForm.value, calculatedTaxFreeLumSum: this.calculatedTaxFreeLumSum }
    ));
    this.router.navigate(['/home/your-dependant']);
  }

  ngAfterViewInit() {
    this.utilService.refreshToggleButton();
    this.ref.detectChanges();
  }
  ngOnDestroy() {
    if (this.subscripYourPension) {
      this.subscripYourPension.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.subscripEmitEdit) {
      this.subscripEmitEdit.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }
  resetSliderToUnselected = () => {
    if (this.userInputDetail.sliderTermConfig.unselectedByDefault &&
      this.quoteForm.controls['termplan']) {
      this.quoteForm.controls['termplan'].setValue(null);
    }
    if (this.selectedProduct.productCode === 'H') {
      if (this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault &&
        this.quoteForm.controls['termmonth']) {
        this.quoteForm.controls['termmonth'].setValue(null);
      }
    }
    if (this.userInputDetail.sliderperiodOfIncomeConfig.unselectedByDefault &&
      this.quoteForm.controls['periodofincome']) {
      this.quoteForm.controls['periodofincome'].setValue(null);
    }
    if (this.userInputDetail.sliderTermConfig.unselectedByDefault &&
      this.quoteForm.controls['termyear']) {
      this.quoteForm.controls['termyear'].setValue(null);
    }
    if (this.selectedProduct.productCode === 'G') {
      if (this.userInputDetail.sliderMonthlyTermConfig.unselectedByDefault &&
        this.quoteForm.controls['termmonth']) {
        this.quoteForm.controls['termmonth'].setValue(null);
      }
    }
  }
  // Method to set quote type
  setQuoteType = () => {
    if (this.selectedProduct.productCode === this.productCms.FTRPCode) {
      this.selectedQuoteType = this.productCms.quoteTypes.ivpp.toUpperCase();
    } else if (this.selectedProduct.productCode === this.productCms.CORPCode) {
      this.selectedQuoteType = this.productCms.quoteTypes.ivpp.toUpperCase();
    } else if (this.selectedProduct.productCode === this.productCms.LTACode) {
      if (this.fundingSource === 'I') {
        this.selectedQuoteType = this.productCms.quoteTypes.internal.toUpperCase();
      } else if (this.fundingSource === 'B') {
        if (this.calculatedTaxFreeLumSum === null || this.calculatedTaxFreeLumSum === 0) {
          this.selectedQuoteType = this.productCms.quoteTypes.omo.toUpperCase();
        } else {
          this.selectedQuoteType = this.productCms.quoteTypes.ivpp.toUpperCase();
        }
      } else {
        this.selectedQuoteType = this.productCms.quoteTypes.omo.toUpperCase();
      }
    }
  }
  processPensionData = () => {
    const fundProvider = this.yourPensionData.fundProvider;
    this.source = null;
    this.pensionArray = [];
    this.multipleTaxfree = false;
    let fundValue = null;
    switch (fundProvider) {
      case 'I':
        this.source = 'L&G';
        fundValue = this.yourPensionData.internal.fundValue;
        break;
      case 'H':
        this.source = 'AEGON';
        fundValue = this.yourPensionData.aegon.fundValue;
        break;
      case 'F':
        this.source = 'SLOC';
        fundValue = this.yourPensionData.sunLife.fundValue;
        break;
      case 'J':
        this.source = 'ReAssure';
        fundValue = this.yourPensionData.reAssure.fundValue;
        break;
      case 'B':
        this.source = 'external';
        break;
      case 'L':
        this.source = 'PensionBee';
        break;
      case 'M':
        this.source = 'Aon';
        break;
      case 'O':
        this.source = 'PHO';
        fundValue = this.yourPensionData.phoenixLife.fundValue;
        break;
      /*case 'M':
        this.source = 'DDP1';
        break;
      case 'N':
        this.source = 'DDP2';
        break;
      case 'O':
        this.source = 'DDP3';
        break;
      case 'P':
        this.source = 'DDP4';
        break;*/
      default:
        break;
    }
    if (this.productsChoice && fundProvider !== 'B' && !DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(fundProvider)) {
      this.pensionArray.push({ name: this.source, fundValue: fundValue ? Number(fundValue.toString().replace(/,/g, '')) : null });
      // tslint:disable-next-line: max-line-length
      if (this.yourPensionData.external && this.yourPensionData.external.fundValue && Number(this.yourPensionData.external.fundValue.toString().replace(/,/g, '')) > 0) {
        this.pensionArray.push({ name: 'external', fundValue: this.yourPensionData.external.fundValue });
      }
      if (this.pensionArray && this.pensionArray.length > 1) {
        this.multipleTaxfree = true;
        this.userInputDetail.radioButtontaxfreeCashConfig.questionStatement =
          this.userInputDetail.radioButtontaxfreeCashConfig.questionStatementFTRPCORP.replace('[select]',
          (this.source === 'SLOC' ? 'Sun Life Financial of Canada' : (this.source === 'L&G' ? 'Legal & General' : (this.source === 'PHO' ? 'Phoenix Life' : this.source))));
      } else if (this.source === 'external' || this.source === 'PensionBee' || this.source === 'Aon') {
        this.userInputDetail.radioButtontaxfreeCashConfig.questionStatement = this.userInputDetail.radioButtontaxfreeCashConfig.questionStatementSingleSource;
      } else {
        this.userInputDetail.radioButtontaxfreeCashConfig.questionStatement =
          this.userInputDetail.radioButtontaxfreeCashConfig.questionStatementFTRPCORP.replace('[select]',
          (this.source === 'SLOC' ? 'Sun Life Financial of Canada' : (this.source === 'L&G' ? 'Legal & General' : (this.source === 'PHO' ? 'Phoenix Life' : this.source))));
      }
    } else {
      this.pensionArray.push({ name: this.source, fundValue: this.yourPensionData.totalSum });
    }
  }
  taxfreeChangeHandler = (val, control) => {
    if (control === 'first') {
      const fundValue = (this.pensionArray && this.pensionArray.length > 0) ? this.pensionArray[0].fundValue : null;
      const fundValueTaxfree = this.quoteForm.controls['fundValueTaxfree'];
      val = parseFloat(val.replace(/,/g, ''));
      this.taxfreePerc = (val * 100) / fundValue;
      this.userInputDetail.taxfreeValueConfig.titleValue = this.taxfreePerc.toFixed(3).toString();
      if (this.taxfreePerc && this.taxfreePerc > 25) {
        fundValueTaxfree.setErrors({ invalidTaxfree: true });
      } else {
        fundValueTaxfree.setErrors(null);
      }
    } else if (control === 'second') {
      let fundValue;
      if (this.fundingSource === 'B' && this.selectedProduct.productCode == 'C') {
        fundValue = (this.pensionArray && this.pensionArray.length == 1) ? this.pensionArray[0].fundValue : null;
        this.quoteForm.controls['fundValueTaxfree'].setValidators([]);
        this.quoteForm.controls['taxfreeRadioButton'].setValidators([]);

        this.quoteForm.controls['fundValueTaxfree'].updateValueAndValidity();
        this.quoteForm.controls['taxfreeRadioButton'].updateValueAndValidity();
      } else {
        fundValue = (this.pensionArray && this.pensionArray.length > 1) ? this.pensionArray[1].fundValue : null;
        if (fundValue && fundValue != null && isNaN(fundValue)) {
          fundValue = Number((fundValue).toString().replace(/,/g, ''));
        }
        this.quoteForm.controls['fundValueTaxfree'].setValidators([Validators.required]);
        this.quoteForm.controls['taxfreeRadioButton'].setValidators([Validators.required]);

        this.quoteForm.controls['fundValueTaxfree'].updateValueAndValidity();
        this.quoteForm.controls['taxfreeRadioButton'].updateValueAndValidity();
      }

      const fundValueTaxfreeSecondary = this.quoteForm.controls['fundValueTaxfreeSecondary'];
      val = parseFloat(val.replace(/,/g, ''));
      this.taxfreePercSecondary = (val * 100) / fundValue;
      this.userInputDetail.secondaryTaxfreeValueConfig.titleValue = this.taxfreePercSecondary.toFixed(3).toString();
      if (this.taxfreePercSecondary && this.taxfreePercSecondary > 25) {
        fundValueTaxfreeSecondary.setErrors({ invalidTaxfree: true });
      } else {
        fundValueTaxfreeSecondary.setErrors(null);
      }
    }
  }
  checkTaxfreeValidations = () => {
    const taxfreeRadioButton = this.quoteForm.controls['taxfreeRadioButton'];
    const taxfreelumpsum = this.quoteForm.controls['taxfreelumpsum'];
    const fundValueTaxfree = this.quoteForm.controls['fundValueTaxfree'];
    const taxfreeRadioButtonSecondary = this.quoteForm.controls['taxfreeRadioButtonSecondary'];
    const taxfreelumpsumSecondary = this.quoteForm.controls['taxfreelumpsumSecondary'];
    const fundValueTaxfreeSecondary = this.quoteForm.controls['fundValueTaxfreeSecondary'];
    const minFundValue = (this.selectedProduct.productCode == 'C') ? this.yourPensionACE.minPensionValue : this.yourPensionACE.GIAPensionValue;
    if (taxfreeRadioButton && taxfreeRadioButton.value) {
      switch (taxfreeRadioButton.value) {
        case 'N':
          taxfreeRadioButton.setErrors(null);
          taxfreelumpsum.setErrors(null);
          fundValueTaxfree.setErrors(null);
          break;
        case 'P':
          if (this.userInputDetail.sliderTaxfreeLumpsumConfig.unselectedByDefault) {
            taxfreelumpsum.setErrors({ notValid: true });
          } else {
            if (this.pensionArray.length > 0) {
              const fundValue = this.pensionArray[0].fundValue;
              const netFund = fundValue - this.taxFreeFund;
              const minLTA = parseFloat(minFundValue);
              if (netFund - minLTA < 0) {
                /* defect# 3376 - check whether fundvalue is provided from more than one source,
                 if so, then add fundValues from both sources */
                if (this.pensionArray.length > 1 && this.pensionArray[1].fundValue) {
                  const totalFund = this.pensionArray[0].fundValue + this.pensionArray[1].fundValue;
                  /* check whether totalFundValue is less than 10k, if the totalFund is less than 10k
                  display error message else don't display the error message */
                  if (totalFund < 10000) {
                    taxfreelumpsum.setErrors({ invalidLTAMin: true });
                  } else {
                    taxfreelumpsum.setErrors(null);
                  }
                } else {
                  taxfreelumpsum.setErrors({ invalidLTAMin: true });
                }
              } else {
                taxfreelumpsum.setErrors(null);
              }
            } else {
              taxfreelumpsum.setErrors(null);
            }
          }
          taxfreeRadioButton.setErrors(null);
          fundValueTaxfree.setErrors(null);
          break;
        case 'A':
          taxfreeRadioButton.setErrors(null);
          taxfreelumpsum.setErrors(null);
          if (!fundValueTaxfree.value) {
            fundValueTaxfree.setErrors({ required: true });
          } else if (this.taxfreePerc && this.taxfreePerc > 25) {
            fundValueTaxfree.setErrors({ invalidTaxfree: true });
          } else {
            if (this.pensionArray.length > 0) {
              const fundValue = this.pensionArray[0].fundValue;
              let fundTaxFreeCashValue = this.quoteForm.controls['fundValueTaxfree'].value;
              if (fundTaxFreeCashValue && fundTaxFreeCashValue != null && isNaN(fundTaxFreeCashValue)) {
                fundTaxFreeCashValue = Number((fundTaxFreeCashValue).toString().replace(/,/g, ''));
              }


              const netFund = fundValue -
                (this.quoteForm.controls['fundValueTaxfree'] && fundTaxFreeCashValue ? parseFloat(fundTaxFreeCashValue) : 0);
              const minLTA = parseFloat(minFundValue);
              if (netFund - minLTA < 0) {
                // fundValueTaxfree.setErrors({ invalidLTAMin: true });
                if (this.pensionArray.length > 1 && this.pensionArray[1].fundValue) {
                  const totalFund = this.pensionArray[0].fundValue + this.pensionArray[1].fundValue;
                  /* check whether totalFundValue is less than 10k, if the totalFund is less than 10k
                  display error message else don't display the error message */
                  if (totalFund < 10000) {
                    fundValueTaxfree.setErrors({ invalidLTAMin: true });
                  } else {
                    fundValueTaxfree.setErrors(null);
                  }
                } else {
                  fundValueTaxfree.setErrors({ invalidLTAMin: true });
                }
              } else {
                fundValueTaxfree.setErrors(null);
              }
            } else {
              fundValueTaxfree.setErrors(null);
            }
          }
      }
    }
    if ((this.multipleTaxfree) || (this.fundingSource === 'B' && this.selectedProduct.productCode == 'C')) {
      if (taxfreeRadioButtonSecondary && taxfreeRadioButtonSecondary.value) {
        switch (taxfreeRadioButtonSecondary.value) {
          case 'N':
            taxfreeRadioButtonSecondary.setErrors(null);
            taxfreelumpsumSecondary.setErrors(null);
            fundValueTaxfreeSecondary.setErrors(null);
            if (this.fundingSource === 'B' && this.selectedProduct.productCode == 'C') {
              this.quoteForm.controls['fundValueTaxfree'].setValidators([]);
              this.quoteForm.controls['taxfreeRadioButton'].setValidators([]);

              this.quoteForm.controls['fundValueTaxfree'].updateValueAndValidity();
              this.quoteForm.controls['taxfreeRadioButton'].updateValueAndValidity();
            }
            break;
          case 'P':
            if (this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.unselectedByDefault) {
              taxfreelumpsumSecondary.setErrors({ notValid: true });
            } else {
              if (this.pensionArray.length > 0 && this.fundingSource === 'B' && this.selectedProduct.productCode == 'C') {
                const fundValue = this.pensionArray[0].fundValue;
                const netFund = fundValue - this.taxFreeFundSecondary;
                const minLTA = parseFloat(minFundValue);
                if (netFund - minLTA < 0) {
                  taxfreelumpsumSecondary.setErrors({ invalidLTAMin: true });

                } else {
                  taxfreelumpsumSecondary.setErrors(null);
                  fundValueTaxfreeSecondary.setErrors(null);
                }
              } else {
                taxfreeRadioButtonSecondary.setErrors(null);
                fundValueTaxfreeSecondary.setErrors(null);
              }
            }

            break;
          case 'A':
            taxfreeRadioButtonSecondary.setErrors(null);
            taxfreelumpsumSecondary.setErrors(null);
            if (!this.taxfreePercSecondary) {
              fundValueTaxfreeSecondary.setErrors({ required: true });
            } else if (this.taxfreePercSecondary && this.taxfreePercSecondary > 25) {
              fundValueTaxfreeSecondary.setErrors({ invalidTaxfree: true });
            } else {
              if (this.pensionArray.length > 0 && this.fundingSource === 'B' && this.selectedProduct.productCode == 'C') {
                const fundValue = this.pensionArray[0].fundValue;
                let fundTaxFreeCashValue = this.quoteForm.controls['fundValueTaxfreeSecondary'].value;
                if (fundTaxFreeCashValue && fundTaxFreeCashValue != null && isNaN(fundTaxFreeCashValue)) {
                  fundTaxFreeCashValue = Number((fundTaxFreeCashValue).toString().replace(/,/g, ''));
                }
                const netFund = fundValue - (this.quoteForm.controls['fundValueTaxfreeSecondary'] &&
                  fundTaxFreeCashValue ? parseFloat(fundTaxFreeCashValue) : 0);
                const minLTA = parseFloat(minFundValue);
                if (netFund - minLTA < 0) {
                  fundValueTaxfreeSecondary.setErrors({ invalidLTAMin: true });
                } else {
                  fundValueTaxfreeSecondary.setErrors(null);
                }
              } else {
                fundValueTaxfreeSecondary.setErrors(null);
              }
            }
        }
      }
    } else {
      taxfreeRadioButtonSecondary.setErrors(null);
      taxfreelumpsumSecondary.setErrors(null);
      fundValueTaxfreeSecondary.setErrors(null);
      if (this.fundingSource === 'B' && this.selectedProduct.productCode == 'C') {
        this.quoteForm.controls['fundValueTaxfree'].setValidators([]);
        this.quoteForm.controls['taxfreeRadioButton'].setValidators([]);

        this.quoteForm.controls['fundValueTaxfree'].updateValueAndValidity();
        this.quoteForm.controls['taxfreeRadioButton'].updateValueAndValidity();
      }
    }
  }
  populateTaxFreeCash = (cardbenefitBasis) => {
    this.showTaxfreeSlider = false;
    this.showTaxfreeInput = false;
    this.showSecondTaxfreeSlider = false;
    this.showSecondTaxfreeInput = false;
    if (cardbenefitBasis.taxFreeCashAmountPercent) {
      this.quoteForm.get('taxfreeRadioButton').setValue(cardbenefitBasis.taxFreeCashAmountPercent);
      this.quoteForm.get('taxfreelumpsum').setValue(null);
      if (cardbenefitBasis.taxFreeCashAmountPercent === 'P') {
        this.quoteForm.get('taxfreelumpsum').setValue(
          // tslint:disable-next-line:radix
          cardbenefitBasis.taxFreeCashPercentage ? parseInt(cardbenefitBasis.taxFreeCashPercentage) : 0);
        this.showTaxfreeSlider = true;
        this.showTaxfreeInput = false;
      }
      this.quoteForm.get('fundValueTaxfree').setValue(null);
      if (cardbenefitBasis.taxFreeCashAmountPercent === 'A') {
        this.quoteForm.get('fundValueTaxfree').setValue(
          cardbenefitBasis.taxFreeCashAmount ?
            CurrencyFunctionalityService.convertNumberToCurrency(parseFloat(cardbenefitBasis.taxFreeCashAmount)) : 0);
        this.showTaxfreeSlider = false;
        this.showTaxfreeInput = true;
      }
    }
    if (cardbenefitBasis.extTaxFreeCashAmountPercent) {
      this.quoteForm.get('taxfreeRadioButtonSecondary').setValue(cardbenefitBasis.extTaxFreeCashAmountPercent);
      this.quoteForm.get('taxfreelumpsumSecondary').setValue(null);
      if (cardbenefitBasis.extTaxFreeCashAmountPercent === 'P') {
        this.quoteForm.get('taxfreelumpsumSecondary').setValue(
          // tslint:disable-next-line:radix
          cardbenefitBasis.extTaxFreeCashPercentage ? parseInt(cardbenefitBasis.extTaxFreeCashPercentage) : 0);
        this.showSecondTaxfreeSlider = true;
        this.showSecondTaxfreeInput = false;
      }
      this.quoteForm.get('fundValueTaxfreeSecondary').setValue(null);
      if (cardbenefitBasis.extTaxFreeCashAmountPercent === 'A') {
        this.quoteForm.get('fundValueTaxfreeSecondary').setValue(
          cardbenefitBasis.extTaxFreeCashAmount ?
            CurrencyFunctionalityService.convertNumberToCurrency(parseFloat(cardbenefitBasis.extTaxFreeCashAmount)) : 0);
        this.showSecondTaxfreeSlider = false;
        this.showSecondTaxfreeInput = true;
      }
    }
  }

  addQuoteData = (res) => {
    if (this.mode === 'view') {
      if (res && res.benefitVariants && res.benefitVariants.length > 0) {
        let newBenefitVariants = res.benefitVariants;
        newBenefitVariants = newBenefitVariants[newBenefitVariants.length - 1];
        const annuitantPension = 'QuoteValue = ' + newBenefitVariants.quickQuoteModel.annuitantPension;
        this.analyticsService.eventTrack({
          type: 'Question',
          name: 'Add quote',
          pageID: this.getCurrentScreenURL(),
          annuityQuoteType: this.quoteForm.value.frequency ? this.quoteForm.value.frequency : null, // to do check with Matt
          annuityQuote: annuitantPension,
          pensionPot: this.yourPensionData.totalSum ? this.yourPensionData.totalSum : null,
          income: this.quoteForm.value.advance ? this.quoteForm.value.advance : null,
          paymentPeriod: this.quoteForm.value.periodofincome ? this.quoteForm.value.periodofincome : null
        });
      }
    }
    const periodofincome = this.quoteForm.controls['periodofincome'];
    let cardCreated = true;
    let selectedIndex = null;
    if (res.error || res.warning) {
      if (res.error && res.error.includes('Select either no guarantee or a full term guarantee')) {
        // this.ACEErrorString = res.error;
        periodofincome.setErrors({ customErrorMessage: true });
        // tslint:disable-next-line:max-line-length
        this.ACEErrorString = 'Your chosen maturity value is too much for your pension savings. We\'ll calculate the maximum maturity value but no yearly income will be possible so your guarantee period must be none or whole term';
        this.userInputDetail.radioButtonPeriodOfIncomeConfig.questionOptions.forEach(val => {
          if (val.code === 'O') {
            val.disable = true;
          }
        });
        this.resetGuaranteedPeriod();
        this.utilService.refreshToggleButton();
      } else if (res.error && res.error.includes('4235 Guarantee Period must cover whole term for non-advised CORP')) {
        // tslint:disable-next-line: max-line-length
        this.ACEErrorString = 'Your chosen yearly income is too much. The maximum income is approximately your pension pot amount divided by your chosen term';
        // this.largeMaturityValueACEErrorFlag = true;
        periodofincome.setErrors(null);
      }
      else { // added this line if there is any ace or generic error
        this.aceErrorNotification(res.error);
      }
      cardCreated = false;
      // if (res.error) {
      //   this.formatError(res.error);
      // } else if (res.warning) {
      //   this.formatError(res.warning);
      // }
    } else {
      this.ACEErrorString = null;
      let newBenefitVariants = (res && res.benefitVariants && res.benefitVariants.length > 0) ? res.benefitVariants : [];
      if (this.mode === 'edit') {
        if (newBenefitVariants.length > 0) {
          selectedIndex = newBenefitVariants.findIndex(val => val.cardNumber === this.selectedCardNumber);
          newBenefitVariants = newBenefitVariants.filter(val => val.cardNumber === this.selectedCardNumber);
        }
        newBenefitVariants = newBenefitVariants.length > 0 ? newBenefitVariants[0] : [];
        // tslint:disable-next-line: max-line-length
        const warning = newBenefitVariants.warning ? newBenefitVariants.warning.find(e => e.includes('Quote varied to maximum Mat Value that can be supported')) : '';
        if (warning !== '') {
          // this.formatError(res.warning);
          // this.ACEErrorString = 'Your maturity amount is the maximum for your fund so we cannot pay you an income';
          this.maturityValErrorFlag = true;
        } else {
          this.ACEErrorString = null;
        }
      } else {
        newBenefitVariants = newBenefitVariants[newBenefitVariants.length - 1];
        // tslint:disable-next-line: max-line-length
        const warning = newBenefitVariants.warning ? newBenefitVariants.warning.find(e => e.includes('Quote varied to maximum Mat Value that can be supported')) : '';
        if (warning !== '') {
          // this.ACEErrorString = 'Your maturity amount is the maximum for your fund so we cannot pay you an income';
          this.maturityValErrorFlag = true;
        }
      }
      cardCreated = true;
    }
    // this.router.navigate(['/quote/quote-variants']);
    if (cardCreated && this.mode === 'edit') {
      this.enableViewMode();
      const params = { mode: true, index: selectedIndex + 1 };
      this.emittedPageMode.emit(params);
    } else if (cardCreated && this.mode === 'view') {
      this.enableViewMode();
      const params = {
        mode: false,
        index: ((res && res.benefitVariants) ? res.benefitVariants.length : this.globalIndex)
      };
      this.emittedPageMode.emit(params);
    } else {
      this.globalIndex = this.globalIndex - 1;
    }
    this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
    this.buttonService.handleButtonLoaderFlag({ flag: false });
    this.loadingFlag = false;
  }
  closeLockedModal() {
    this.isLocked = false;
  }
  closeLMVErrorModal() {
    this.maturityValErrorFlag = false;
  }
  aceErrorNotification(errorACE: any) {
    if (errorACE === 'A') {
      this.aceAlertModal = this.cmsACE.aceModalError;
      this.displayACEFlag = true;
    } else {
      this.aceAlertModal = this.cmsACE.alternateACEErrorModal;
      this.displayACEFlag = true;
    }
  }
  alertErrorPrimaryBtnClick() {
    this.closeErrorModal();
    if (this.aceAlertModal.footerPrimaryBtnLabel === 'Retry') {
      this.proceedAsNormal(); //this.gotoNextPage(); 
    }
  }
  closeErrorModal() {
    this.displayACEFlag = false;
    this.noWarningMSg = (this.dontShowMsgAgain === true ? true : false);
  }
  dontShowUPMsgAgain(val) {
    this.dontShowMsgAgain = val;
  }
  setTaxfreeLabel = () => {
    if (this.yourOptions.calculatedTaxFreeLumSum && this.yourOptions.calculatedTaxFreeLumSum.length > 0) {
      this.yourOptions.calculatedTaxFreeLumSum.forEach(taxFree => {
        if (taxFree.mode === 'primary') {
          this.taxfreePerc = taxFree.perc;
          this.taxFreeFund = taxFree.value;
        }
        if (taxFree.mode === 'secondary') {
          this.taxfreePercSecondary = taxFree.perc;
          this.taxFreeFundSecondary = taxFree.value;
        }
      });
    }
  }
  // DTC-3649 "As soon as possible" button Event
  toggleCurrentDate(value) {
    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1;
    let strDate = dd.toString();
    let strMonth = mm.toString();
    const yyyy = today.getFullYear();
    if (dd < 10) {
      strDate = '0' + dd.toString();
    }
    if (mm < 10) {
      strMonth = '0' + mm.toString();
    }
    const formattedDate = strDate + ' / ' + strMonth + ' / ' + yyyy;
    //this.quoteForm.get('currentDate').setValue(value.code);
    this.quoteForm.get('startDate').setValue(formattedDate);
    this.dateChange([false, false]);
    this.currentDateFlag = true;
    this.startDateBeforeFormChanged = formattedDate;
  }
  // DTC-3649 Start Date Event
  dateChange(val) { // start date should be available to execute the function. 
    if (this.quoteForm.controls.startDate && this.quoteForm.controls.startDate.value) {
      const startDateType = this.quoteForm.controls.currentDate.value;
      const today = new Date();
      const startDate = this.quoteForm.controls.startDate.value;
      if (this.currentDateFlag && this.startDateBeforeFormChanged !== startDate) {
        if (val[0] === true && val[1] === false) {
          this.currentAndStartDateError = (startDateType === 'A') ? true : false;
        } else {
          this.currentAndStartDateError = false;
          // check condition when both As soon as possible and date field are selected
          this.quoteForm.controls['currentDate'].setValue(null);
          this.quoteForm.controls.currentDate.markAsUntouched();
          this.currentDateFlag = false;
          // de-selects/ refreshes the selected button value
          this.utilService.refreshToggleButton();
        }
      }
    }
  }
  // DTC-1219 New requirement : Reset Guarantee Options to Whole Term
  resetGuaranteedPeriod() {
    this.quoteForm.controls['periodofincomequestion'].setValue('F');
    this.quoteForm.controls['periodofincomequestion'].markAsTouched();
    this.periodOfIncomeSliderVisibility = false;
  }
  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    //console.log('changed value = ', this.contentData.introduction);

    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourProductOptions;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.introduction = this.CMSData.string_YourPensionAnnuitySubtitle;
        this.contentData.notificationBanner = this.CMSData.string_IntoductionWording;
		    this.contentData.string_GuaranteedIncomeWarningMessage = this.CMSData.string_GuaranteedIncomeWarningMessage;
        this.userInputDetail.radioButtonAdvanceConfig.infoIconData.content = this.CMSData.string_AdvanceArrearsInformationWording;
        this.userInputDetail.radioButtontaxfreeCashConfig.infoIconData.content = this.CMSData.string_FTRP_CORP_TFCInfoPointText1;
        this.userInputDetail.radioButtonincraeseincomeConfig.infoIconData.content = this.CMSData.string_IncomeIncreaseInformationWording;
        this.userInputDetail.radioButtontaxfreeCashConfig.infoIconData.content = this.CMSData.string_TFCInfoPointText1 + '<br/><br/>' + this.CMSData.string_TFCInfoPointText4;
        this.userInputDetail.radioButtontaxfreeCashOthersConfig.infoIconData.content = this.CMSData.string_TFCInfoPointText1 + '<br/><br/>' + this.CMSData.string_TFCInfoPointText4;
        if (this.selectedProduct.productCode === 'H' || this.selectedProduct.productCode === 'G') {
          this.userInputDetail.radioButtonincraeseincomeConfig.infoIconData.content = this.CMSData.string_FTRPAndCORPIncomeIncreaseInformationWording;
          this.userInputDetail.radioButtontaxfreeCashConfig.infoIconData.content = this.CMSData.string_TFCInfoPointText1 + '<br/><br/>' + this.CMSData.string_TFCInfoPointText2 + '<br/><br/>' + this.CMSData.string_TFCInfoPointText3;
          this.userInputDetail.radioButtontaxfreeCashOthersConfig.infoIconData.content = this.CMSData.string_TFCInfoPointText1 + '<br/><br/>' + this.CMSData.string_TFCInfoPointText2 + '<br/><br/>' + this.CMSData.string_TFCInfoPointText3;
        }
        
        this.userInputDetail.sliderTaxfreeLumpsumConfig.infoIconData.content = this.CMSData.string_TFCInformationWording;
        this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.infoIconData.content = this.CMSData.string_TFCInformationWording;
        this.userInputDetail.sliderIncomePercentageConfig.zeroValidationMsg = this.CMSData.string_SpousePensionErrorMessage;
        this.userInputDetail.radioButtonPeriodOfIncomeConfig.infoIconData.content = this.CMSData.string_GuaranteedIncomeFTRPInformationMessage;
        this.userInputDetail.sliderperiodOfIncomeConfig.infoIconData.content = this.CMSData.string_GuaranteedIncomePAInformationMessage;
        this.contentData.calculateButton = this.CMSData.string_AddQuoteLTALabel;
        this.contentData.editCalcButn = this.CMSData.string_EditQuoteCTALabel;
        this.contentData.chooseBtn = this.CMSData.string_ChooseQuoteCTALabel;
        this.contentData.doneEditingBtn = this.CMSData.string_DoneEditingCTALabel;
        this.userInputDetail.fundValueConfig.infoIconData.content = this.CMSData.string_FtrpIncomeInformationWording;
        this.userInputDetail.radioButtonincomeMaturityConfig.infoIconData.content = this.CMSData.string_FtrpIncomeMaturityValueInformationWording;

        this.userInputDetail.radioButtonFrequencyConfig.questionStatement = this.CMSData.string_PAIncomeFrequencyQuestion;
        this.userInputDetail.radioButtonAdvanceConfig.questionStatement = this.CMSData.string_AdvanceArrearsQuestion;
        this.userInputDetail.radioButtonAdvanceFTRPConfig.questionStatement = this.CMSData.string_AdvanceArrearsQuestion;
        this.userInputDetail.radioButtonincraeseincomeConfig.questionStatement = this.CMSData.string_IncomeIncreaseQuestion;
        this.userInputDetail.sliderIncomePercentageConfig.sliderTitle = this.CMSData.string_DependantIncomeQuestion;
        this.userInputDetail.slidervpConfig.sliderTitle = this.CMSData.string_VpPercentageQuestion;
        this.userInputDetail.radioButtontaxfreeCashConfig.questionStatementSingleSource = this.CMSData.string_TFCNonDealPartnerQuestion;
        this.userInputDetail.radioButtonincomeMaturityConfig.questionStatement = this.CMSData.string_FTRPIncomeMaturityValueQuestion;
        this.contentData.middleText = this.CMSData.string_ChooseQuoteWording;
        this.userInputDetail.radioButtonFTRPFrequencyConfig.infoIconData.content = this.CMSData.string_IncomeFrequencyInformationWording;
        this.userInputDetail.radioButtonFrequencyConfig.infoIconData.content = this.CMSData.string_IncomeFrequencyInformationWording;
        // this.userInputDetail.sliderIncomePercentageConfig.infoIconData.content = this.CMSData.string_DependantNotSelectedInformationWording
        //   + this.CMSData.string_DependantNotSelectedInformationLinkText;
        // tslint:disable-next-line:max-line-length
        this.userInputDetail.sliderIncomePercentageConfig.infoIconData.disabledInfoIconTextPartA = this.CMSData.string_DependantNotSelectedInformationWording;
        // tslint:disable-next-line:max-line-length
        this.userInputDetail.sliderIncomePercentageConfig.infoIconData.disabledInfoIconTextPartB = this.CMSData.string_DependantNotSelectedInformationLinkText;
        // add dependant check here if yes
        if (this.dependantDetailsData && (this.dependantDetailsData.dependantQuestion === 'Y')) {
          this.userInputDetail.sliderIncomePercentageConfig.infoIconData.content = this.CMSData.string_ValueProtectionPercentageInformationWording;
        }
        /** Check for product choice = FTRP for frequency question for selecting external 2 tax free cash from ceding fund*/
        if (this.multipleTaxfree === true) {
          this.userInputDetail.radioButtonFTRPFrequencyConfig.questionStatement = this.CMSData.string_TFCNonDealPartnerQuestion;
        }
        if (this.source === 'external' || this.source === 'PensionBee' || this.source === 'Aon') {
          this.userInputDetail.radioButtontaxfreeCashConfig.questionStatement = this.CMSData.string_TFCNonDealPartnerQuestion;
        } else {
          let sourceVal = (this.source === 'SLOC' ? 'Sun Life Financial of Canada' : (this.source === 'L&G' ? 'Legal & General' : (this.source === 'PHO' ? 'Phoenix Life' : this.source)));
          this.userInputDetail.radioButtontaxfreeCashConfig.questionStatementFTRPCORP = this.CMSData.string_TFCDealPartnerQuestion1 + sourceVal +
            this.CMSData.string_TFCDealPartnerQuestion2;
        }
        this.userInputDetail.radioButtontaxfreeCashOthersConfig.questionStatement = this.source === 'external'
          ? this.CMSData.string_TFCNonDealPartnerQuestion : this.CMSData.string_TFCOtherProviderQuestion;

        /** Check for product choice = FTRP for frequency question */
        if (this.selectedProduct.productCode === 'H') {
          this.userInputDetail.radioButtonFTRPFrequencyConfig.questionStatement = this.CMSData.string_GIIncomeFrequencyQuestion;
          // this.userInputDetail.radioButtonFTRPFrequencyConfig.questionStatement = this.multipleTaxfree === true ?
          // this.CMSData.string_TFCNonDealPartnerQuestion : this.CMSData.string_GIIncomeFrequencyQuestion;
        }
        this.userInputDetail.radioButtonvalueProtectionConfig.questionStatement = this.CMSData.string_VpGuaranteedIncomeQuestion;
        this.userInputDetail.slidervpConfig.infoIconData.content = this.CMSData.string_ValueProtectionDependantInformationWording;
        if (this.dependantDetailsData && this.dependantDetailsData.dependantQuestion === 'Y') {
          this.userInputDetail.slidervpConfig.infoIconData.disabledInfoIconTextPartA = this.CMSData.string_ValueProtectionDependantInformationWording;
        }
        this.userInputDetail.radioButtontaxfreeCashConfig.questionStatementFTRPCORP = this.CMSData.string_TFCDealPartnerQuestion1 + '[select]' +
          this.CMSData.string_TFCDealPartnerQuestion2;
        this.userInputDetail.taxfreeValueConfig.invalidLTAMinMsg = this.CMSData.string_MinPensionFundAfterTFCErrorMessage + '[LTAMin]';
        this.userInputDetail.taxfreeValueConfig.invalidTaxfreeMessage = this.CMSData.string_TFCExceedsDPFundErrorMessage + '[dealpartner]';
        this.userInputDetail.sliderTermConfig.sliderTitle = this.CMSData.string_PlanTermQuestion;
        this.userInputDetail.sliderTermConfig.infoIconData.content = this.CMSData.string_FtrpTermInformationWording;
        this.currentDateConfig.questionStatement = this.CMSData.string_PlanStartDate;
        this.currentDateConfig.infoIconData.content = this.CMSData.string_PlanStartDateInformationWording;
        this.userInputDetail.startDate.StartDateThreeMonthsError = this.CMSData.string_StartDateThreeMonthsError;
        this.userInputDetail.startDate.StartDateAge55Error = this.CMSData.string_StartDateAge55Error;
        this.currentDateConfig.validationMsg = this.CMSData.string_StartDateErrorMessage;
        this.contentData.valueProtectionWarningMessage = this.CMSData.string_ValueProtectionWarningMessage;
        if (this.userInputDetail.sliderTermConfig.sliderType === 'Price') {
          this.userInputDetail.sliderTermConfig.sliderType = this.CMSData.string_TFCAmount;
        }
        /** If there is no deal partner and only one fund, then this is the error message */
        if (this.multipleTaxfree === false) {
          this.userInputDetail.taxfreeValueConfig.invalidTaxfreeMessage = this.CMSData.string_TFCExceedsOtherFundErrorMessage;
          this.userInputDetail.secondaryTaxfreeValueConfig.invalidTaxfreeMessage = this.CMSData.string_TFCExceedsOtherFundErrorMessage;
        } else {
          this.userInputDetail.secondaryTaxfreeValueConfig.invalidTaxfreeMessage = this.CMSData.string_TFCExceedsOtherFundErrorMessage;
        }
        this.userInputDetail.radioButtonvalueProtectionConfig.validationMsg = this.CMSData.string_DeathBensError;
        // tslint:disable-next-line:max-line-length
        this.userInputDetail.radioButtonvalueProtectionConfig.infoIconData.content = this.CMSData.string_DeathBensInformationWording;
        this.userInputDetail.radioButtonincraeseincomeConfig.validationMsg = this.CMSData.string_IncomeIncreaseError;
        this.userInputDetail.radioButtonAdvanceConfig.validationMsg = this.CMSData.string_PaymentErrorMessage;
        this.userInputDetail.radioButtontaxfreeCashConfig.validationMsg = this.CMSData.string_TFCNoSelectionErrorMessage;

        this.userInputDetail.sliderTaxfreeLumpsumConfig.invalidLTAMinMsg = this.CMSData.string_MinPensionFundAfterTFCErrorMessage + '[LTAMin]';
        this.userInputDetail.sliderTaxfreeLumpsumConfigSecondary.invalidLTAMinMsg = this.CMSData.string_MinPensionFundAfterTFCErrorMessage + '[LTAMin]';
        // this.userInputDetail.radioButtonPeriodOfIncomeConfig.infoIconData.content = this.CMSData.string_FtrpGuaranteedPeriodInformationWording;

        this.userInputDetail.taxfreeValueConfig.infoIconData.content = this.CMSData.string_TFCInformationWording;
        this.cmsGenaralConstants.zeroIncomeError = this.CMSData.string_GuaranteedMinErrorMessage;
        //console.log('changed value = ', this.contentData.introduction);
      }
    });
  }
  GetCMSDataQuoteUnavailableMapper() {
    //console.log('changed value = ', this.contentData.introduction);

    const URL = SERVICE_END_POINT.higherEnvironment.CMS_ShortModal_QuoteNotAvailableError;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSDataQuoteUnavailable = res;
      if (this.CMSDataQuoteUnavailable) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.cmsACE.aceModalError.header = this.CMSDataQuoteUnavailable.string_QuoteNotReturnedTitle;
        // tslint:disable-next-line:max-line-length
        this.cmsACE.aceModalError.content = this.CMSDataQuoteUnavailable.html_QuoteNotReturnedText_1 + this.CMSDataQuoteUnavailable.html_QuoteNotReturnedText_2;

      }
    });
  }
  /** End of code block for CMS */
  /** For web tracking */
  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);

    return this.screenName;
  }
  // test

  // (defect-6437) Format the currency on swith of question taxfree cash
  formatCurrency = (amount) => {
    if(amount && amount != '') {
      const tempString = amount.replace(/,/g, '');
      amount = tempString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return amount;
  }

  increaseIncomeValues(){
    return [
      {
          label: 'No',
          code: 'N'
      },
      {
          label: 'Fixed %',
          code: 'F'
      },
      {
          label: 'RPI',
          code: 'R'
      }
  ]
  }

  displayTooltipMessage(config) {
    this.tooltipModal.content = config.infoIconData.content;
    this.displayTooltipAlert = true;
  }

  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }

  displayCorpTooltipMessage(data: string) {
    this.tooltipModal.content = data;
    this.displayTooltipAlert = true;
  }

  closeTooltipModal() {
    this.displayTooltipAlert = false;
  }
}

